export default {
    onboarding: {
        title: 'Maak je Professional-account af',
        subtitle:
            'Rond deze stappen af om je brand en evenementen te beheren. Je kunt op elk moment verdergaan waar je gebleven bent.',
        step_counter: 'Stap {current} van {total}',
        steps: {
            account_created: {
                label: 'Account aanmaken',
                description: 'Je account is klaar — welkom bij LatinMap.',
                cta: '',
            },
            email_verified: {
                label: 'E-mailadres verifiëren',
                description: 'Bevestig je e-mailadres zodat we je kunnen bereiken over je evenementen en account.',
                cta: '',
            },
            sms_verified: {
                label: 'Telefoonnummer verifiëren',
                description: 'Een snelle SMS-verificatie ontgrendelt publiceren en beveiligt je account.',
                cta: 'Verifiëren',
            },
            brand_added: {
                label: 'Brand claimen of aanmaken',
                description: 'Richt je organisatie, dansschool of Professional-profielpagina in.',
                cta: 'Brand toevoegen',
            },
            event_added: {
                label: 'Je eerste event toevoegen',
                description: 'Publiceer een evenement zodat dansers je kunnen vinden op LatinMap.',
                needs_brand:
                    'Je hebt een brand nodig voordat je een event kunt toevoegen. Maak eerst je brand aan, daarna kun je events publiceren.',
                cta: 'Event toevoegen',
                cta_needs_brand: 'Maak eerst een brand',
            },
            dashboard_discovered: {
                label: 'Ontdek je Professional Dashboard',
                description: 'Beheer je brand pages, evenementen, ticketlinks en meer vanaf één plek.',
                cta: 'Dashboard openen',
            },
        },
    },
    cookie_consent: {
        title: 'We hechten waarde aan je privacy',
        intro: 'We gebruiken cookies om LatinMap te laten werken, te begrijpen hoe het wordt gebruikt en het te verbeteren. Jij kiest welke cookies we mogen gebruiken. Noodzakelijke cookies staan altijd aan.',
        always_on: 'Altijd aan',
        accept_all: 'Alles accepteren',
        reject_all: 'Alles weigeren',
        customize: 'Aanpassen',
        save: 'Keuzes opslaan',
        categories: {
            necessary: {
                title: 'Noodzakelijk',
                description:
                    'Nodig om de site te laten werken, zoals je inlogsessie, beveiliging en taal. Deze kunnen niet worden uitgeschakeld.',
            },
            preferences: {
                title: 'Voorkeuren',
                description:
                    'Onthouden van keuzes die je maakt, zoals je voorkeurstaal of regio, voor een persoonlijkere ervaring.',
            },
            statistics: {
                title: 'Statistieken',
                description:
                    'Helpen ons te begrijpen hoe bezoekers LatinMap gebruiken door anonieme gebruiksgegevens te verzamelen (bijv. Google Analytics).',
            },
            marketing: {
                title: 'Marketing',
                description:
                    'Gebruikt om campagnes te meten en je relevantere content te tonen op verschillende platformen (bijv. Meta Pixel, Google Ads).',
            },
        },
    },
    admin: {
        title: 'Admin',
        quick_edit: {
            event: 'Event bewerken',
            brand: 'Brand bewerken',
        },
        superadmin: {
            title: 'Superbeheerder',
            edit: 'Bewerken',
        },
        invite: {
            manage: 'Managers uitnodigen',
            resend: 'Opnieuw verzenden',
            resend_success: 'De uitnodiging is opnieuw verzonden',
        },
        users: {
            edit: {
                singular: 'Gebruiker bewerken',
                plural: 'Gebruikers bewerken',
            },
            active: 'Actief',
            passive: 'Passief',
            overview: 'Gebruikers',
            impersonate: {
                button: 'Imiteren',
                loading: 'Bezig met imiteren...',
                error: 'Kan deze gebruiker niet imiteren.',
            },
        },
        pages: {
            edit: {
                singular: 'Pagina bewerken',
                plural: "Pagina's bewerken",
            },
            update: {
                success: 'De pagina is succesvol bijgewerkt.',
                error: 'Er is een fout opgetreden bij het bijwerken van de pagina.',
                singular: 'Pagina Bijwerken',
                title: 'Titel',
                content: 'Inhoud',
                update_success: 'Pagina succesvol bijgewerkt',
            },
            overview: "Pagina's",
            title: 'Titel',
            content: 'Inhoud',
        },
        prices: {
            update: {
                success: 'De prijzen is succesvol bijgewerkt.',
                singular: 'Prijzen Bijwerken',
                title: 'Titel',
                content: 'Inhoud',
                update_success: 'Prijzen succesvol bijgewerkt',
            },
            success: 'Aanschaf geslaagd',
        },
        events: {
            edit: {
                singular: 'Evenement bewerken',
                plural: 'Evenementen bewerken',
            },
            overview: 'Evenementen',
        },
        organizations: {
            edit: {
                singular: 'Organisatie & Brand bewerken',
                plural: 'Organisaties & Brands bewerken',
            },
            overview: 'Organisaties & Brands',
        },
        // LA-194: the links Admin hands out so an organiser can submit
        // an event without having an account.
        submission_links: {
            title: 'Inzendlinks',
            intro: 'Links waarmee organisatoren zonder account een event kunnen insturen.',
            new: 'Nieuwe link',
            new_hint: 'Maak een link die je per WhatsApp of e-mail aan een organisator geeft.',
            create: 'Link aanmaken',
            created: 'Link aangemaakt',
            search: 'Zoeken',
            copy: 'Kopieer link',
            copied: 'Gekopieerd',
            base_url: 'Elke link begint met:',
            copy_base: 'Kopieer het begin van de link',
            withdraw: 'Intrekken',
            reactivate: 'Heractiveren',
            no_brand: 'Nog geen brand',
            empty: 'Nog geen links.',
            failed: 'Er ging iets mis.',
            has_submissions: 'Er zijn al inzendingen via deze link; trek hem in in plaats van verwijderen.',
            delete_confirm: 'Link {code} verwijderen?',
            fields: {
                code: 'Code',
                label: 'Omschrijving',
                label_placeholder: 'Bijv. Salsa Nights Rotterdam',
                brand: 'Brand',
                brand_placeholder: 'Zoek een brand',
                brand_hint: 'Optioneel. Bepaalt onder welke brand de inzending valt.',
                state: 'Status',
                submissions: 'Inzendingen',
                expires_at: 'Verloopt op',
                max_submissions: 'Max. inzendingen',
                contact_name: 'Contactpersoon',
                contact_email: 'E-mailadres',
            },
            states: {
                all: 'Alle',
                active: 'Actief',
                expired: 'Verlopen',
                withdrawn: 'Ingetrokken',
                full: 'Vol',
            },
        },
        scraped_concepts: {
            title: 'Gescrapete Concepten',
            overview: 'Concepten Overzicht',
            edit: { title: 'Concept Bewerken' },
            columns: {
                source: 'Bron',
                name: 'Naam',
                dates: 'Datums',
                location: 'Locatie',
                organization: 'Organisatie',
                status: 'Status',
                brand_match: 'Brand',
                actions: 'Acties',
            },
            filters: {
                name: 'Evenementnaam',
                source: 'Bron',
                status: 'Status',
                city: 'Stad',
                date_from: 'Datum vanaf',
                date_to: 'Datum tot',
                brand_status: 'Brandstatus',
            },

            brand_status: {
                unchecked: 'Nog niet gecontroleerd',
                unmatched: 'Nog niet op LatinMap',
                unmanaged: 'Bestaat, niet in beheer',
                review: 'Controleren',
                managed: 'In beheer',
            },
            match_signal: {
                email: 'gevonden via e-mailadres',
                domain: 'gevonden via website',
                name: 'gevonden via naam',
                name_city: 'gevonden via naam + plaats',
                fuzzy: 'lijkt erop — controleren',
            },
            unlink_brand: 'Brand ontkoppelen',
            organization_unlinked: 'Brand ontkoppeld',
            unlink_confirm: {
                title: 'Brand ontkoppelen?',
                submit: 'Ja, ontkoppelen',
                body: 'De koppeling tussen "{event}" en de brand "{brand}" weghalen?',
                note: 'Het concept blijft in de lijst staan en kan aan een andere brand gekoppeld worden. Er wordt niets verwijderd.',
            },
            link_confirm: {
                title: 'Brand koppelen?',
                submit: 'Ja, koppelen',
                body: '"{event}" koppelen aan de brand "{brand}"? Het event moet daarna nog apart goedgekeurd worden.',
                signal: 'Gevonden:',
                warning_managed:
                    'Deze brand wordt actief beheerd door een Professional. Een gescrapet event koppelen kan botsen met hun eigen werk.',
                warning_review:
                    'Deze match is niet zeker. Controleer of het echt om dezelfde brand gaat voordat je koppelt.',
            },
            link_match: 'Koppel deze brand',
            refresh_matches: 'Matches verversen',
            refresh_matches_help: 'Opnieuw bepalen bij welke bestaande brands de gescrapete organisatoren horen',
            matches_refreshed: 'Matches ververst: {certain} zeker, {possible} te controleren',
            bulk: {
                selected: '{count} geselecteerd',
                link_matched: 'Koppel gematchte brand',
                approve: 'Goedkeuren',
                reject: 'Afwijzen',
                clear: 'Selectie wissen',
                running: 'Bezig...',
                select_all: 'Alles op deze pagina selecteren',
                select_one: '{name} selecteren',
                nothing_to_link: 'Niets in de selectie heeft een zekere match om te koppelen',
                nothing_to_unlink: 'Niets in de selectie heeft een gekoppelde brand',
                unlink: 'Ontkoppelen',
                result: '{succeeded} verwerkt, {failed} overgeslagen',
                confirm: {
                    title: 'Bulkactie bevestigen',
                    submit: 'Ja, doorgaan',
                    body_approve:
                        '{count} concept(en) publiceren? Concepten zonder bevestigde of zekere brand worden overgeslagen.',
                    body_reject: '{count} concept(en) afwijzen?',
                    body_unlink: 'De brandkoppeling weghalen bij {count} concept(en)?',
                    unlink_skipped: '{skipped} uit de selectie worden overgeslagen: daar hangt geen brand aan.',
                    body_assign:
                        '{count} concept(en) koppelen aan hun gevonden brand? De events moeten daarna nog apart goedgekeurd worden.',
                    assign_skipped:
                        '{skipped} uit de selectie worden overgeslagen: al gekoppeld, of geen zekere match.',
                    and_more: 'en nog {count}',
                    assign_managed:
                        '{count} van deze brands worden actief beheerd door een Professional. Koppelen kan botsen met hun eigen werk.',
                },
            },
            status_labels: { pending: 'In afwachting', approved: 'Goedgekeurd', rejected: 'Afgewezen' },
            no_organization: 'Geen organisatie toegewezen',
            submitted_by: 'Ingezonden door',
            no_results: 'Geen concepten gevonden',
            assign_first: 'Wijs eerst een organisatie toe',
            assign_organization: 'Organisatie Toewijzen',
            search_organization: 'Zoek organisatie op naam',
            current_organization: 'Momenteel toegewezen',
            organization_assigned: 'Organisatie succesvol toegewezen',
            managed_brand: 'Beheerd',
            managed_by: 'Beheerd door',
            active_warning: 'Actief beheerd brand — koppel hier geen gescrapete events',
            active_warning_short: 'Actief account',
            active_confirm: {
                title: 'Actief beheerd brand',
                body: 'Dit brand wordt actief beheerd door een account met geverifieerd telefoonnummer ({email}). Koppelen kan conflicteren met het werk van de eigenaar. Weet je zeker dat je dit concept toch wilt koppelen?',
                submit: 'Toch koppelen',
            },
            approve: 'Goedkeuren',
            reject: 'Afwijzen',
            approved_success: 'Concept goedgekeurd en evenement aangemaakt',
            rejected_success: 'Concept afgewezen',
            view_event: 'Bekijk aangemaakt evenement',
            posted_by_label: {
                title: 'Label "Posted by LatinMap" tonen',
                automatic: 'Automatisch (alleen als LatinMap niet de brand is)',
                yes: 'Ja, toon het label',
                no: 'Nee, niet tonen',
                help: 'Zichtbaar op de publieke eventpagina. De brand haalt het zelf weg door het event te bewerken.',
            },
            open_event_page: 'Open de eventpagina',
            submitted_organizer: 'Organisator volgens de inzender',
            approve_error: 'Kon concept niet goedkeuren',
            save_success: 'Concept succesvol opgeslagen',
            scraped_at: 'Gescraped op',
            view_source: 'Bron bekijken',
            photos: "Foto's",
            admin_notes: 'Admin notities',
            reject_confirm: {
                title: 'Concept Afwijzen',
                body: 'Weet je zeker dat je dit concept wilt afwijzen?',
                submit: 'Afwijzen',
            },
            search_btn: 'Zoeken',
            back: 'Terug',
            missing_fields: 'Vul de verplichte velden in',
            scraping: 'Aan het scrapen',
            scrape_result: '{fetched} opgehaald, {created} aangemaakt, {skipped} overgeslagen, {errors} fouten',
        },
        report: {
            details: 'Details',
            reported: 'Gerapporteerd door:',
            suspended_at: 'Opgeschort op:',
            email: 'Email:',
            phonenumber: 'Telefoonnummer:',
            message: 'Bericht:',
            singular: 'Rapport',
            plural: 'Rapporten',
            reportables: {
                event: 'Evenementen',
                organization: 'Organisaties & brands',
            },
            status: {
                submitted: 'Ingediend',
                under_review: 'Onder herziening',
                resolved: 'Opgelost',
                no_issue: 'Geen probleem',
            },
            reportables_by_type: {
                event: 'Event',
                organisation: 'Organisaties & brands',
                user: 'Gebruiker',
                created_by: 'Aangemaakt door',
                report_by: 'Rapport door',
                ip_adress: 'IP-adres',
                reason: 'Reden',
                description: 'Beschrijving',
                empty: 'leeg',
            },
            no_reports: 'Er zijn geen rapporten gevonden.',
        },
        lead: {
            singular: 'Lead',
            plural: {
                event: 'Event lead',
                organization: 'Brand lead',
            },
            user_type: 'Gebruikerstype',
            user_email: 'Gebruikers e-mail',
        },
        block_user: {
            plural: 'Blokkeer gebruikers',

            title: 'BLOCKED',
            description: 'Uw account is geblokkeerd, u hebt geen toegang meer tot het platform.',
        },
        setting: {
            plural: 'instellingen',
            reset: {
                warning: {
                    title: 'Reset alle instellingen in de admin.',
                    body: 'Weet u zeker dat u alle instellingen wilt resetten?',
                },
            },
        },
        permissions: {
            plural: 'Permissies',
            levels: {
                'level-1': 'Super beheerder',
                'level-2': 'Beheerder',
                'level-3': 'Ambassadeur',
                'level-4': 'Premium lid',
                'level-5': 'Professoneel lid',
                'level-6': 'Lid',
            },
            no_users_with_role: 'Er zijn geen gebruikers met dit rol niveau.',
            rights: {
                'create-organization-on-behalf-of-other-user': 'Organisaties & Brand namens andere gebruiker aanmaken',
                'latinmap-verify': 'LatinMap verificatie status geven',
                invite: {
                    'level-3': 'Ambassadeurs uitnodigen',
                },
                reports: {
                    view: 'Rapporten bekijken',
                    delete: {
                        any: 'Rapporten verwijderen',
                    },
                    update: 'Rapporten bijwerken',
                    export: 'Rapporten exporteren',
                },
                events: {
                    create: 'Evenementen aanmaken',
                    view: 'Evenementen bekijken',
                    update: {
                        any: 'Alle evenementen bijwerken',
                        own: 'Eigen evenementen bijwerken',
                    },
                    delete: {
                        any: 'Alle evenementen verwijderen',
                        own: 'Eigen evenementen verwijderen',
                    },
                    publish: 'Evenementen publiceren',
                    unpublish: 'Evenementen niet publiceren',
                    ownership: {
                        own: 'Eigenaarschap van eigen evenementen wijzigen',
                        any: 'Eigenaarschap van alle evenementen wijzigen',
                    },
                    ticketshop: {
                        enable: 'Ticketshop inschakelen',
                    },
                },
                organisations: {
                    create: 'Organisaties & brands aanmaken',
                    update: {
                        any: 'Alle organisaties & brands bijwerken',
                        own: 'Eigen organisaties & brands bijwerken',
                    },
                    delete: {
                        any: 'Alle organisaties & brands verwijderen',
                        own: 'Eigen organisaties & brands verwijderen',
                    },
                    ownership: {
                        own: 'Eigenaarschap van eigen organisaties & brands wijzigen',
                        any: 'Eigenaarschap van alle organisaties & brands wijzigen',
                    },
                },
                users: {
                    edit: 'Gebruikers bewerken',
                },
                leads: {
                    view: 'Leads bekijken',
                    delete: 'Leads Verwijderen',
                },
                transfer_requests: {
                    view: 'Bekijk overdrachtsverzoeken',
                    approve: 'Overdrachtsverzoeken goedkeuren',
                },
            },
        },
        dance_styles: {
            title: 'Dansstijlen',
            singular: 'Dansstijl',
            create: {
                singular: 'Dansstijl aanmaken',
            },
            edit: {
                singular: 'Dansstijl bewerken',
                plural: 'Dansstijlen bewerken',
            },
            delete: {
                title: 'Dansstijl verwijderen?',
                singular: 'Verwijderen',
                cancel: 'Annuleren',
                confirmation:
                    'Deze dansstijl heeft sub dansstijlen. Weet u zeker dat u deze dansstijl wilt verwijderen?',
                affected:
                    'Deze dansstijl wordt gebruikt in {event_count} evenementen en {organization_count} organisaties & brands. Weet u zeker dat u deze dansstijl wilt verwijderen?',
                label: 'Dansstijl verwijderen',
                placeholder: 'Typ "{keyword}" hier en verzend om de dansstijl te verwijderen.',
            },
            sub_dance_style: 'Sub dansstijl',
            is_favorite: 'Favoriet',
        },
        music_styles: {
            title: 'Muziekstijlen',
            singular: 'Muziekstijl',
            create: {
                singular: 'Muziekstijl aanmaken',
            },
            edit: {
                singular: 'Muziekstijl bewerken',
                plural: 'Muziekstijlen bewerken',
            },
            delete: {
                title: 'Muziekstijl verwijderen?',
                singular: 'Verwijderen',
                cancel: 'Annuleren',
                confirmation:
                    'Deze muziekstijl heeft sub muziekstijlen. Weet u zeker dat u deze muziekstijl en al deze sub muziekstijlen wilt verwijderen?',
                substyles:
                    'Deze muziekstijl heeft sub muziekstijlen. Weet u zeker dat u deze muziekstijl wilt verwijderen?',
                affected:
                    'Deze muziekstijl wordt gebruikt in {event_count} evenementen en {organization_count} organisaties & brands. Weet u zeker dat u deze muziekstijl wilt verwijderen?',
                label: 'Muziekstijl verwijderen',
                placeholder: 'Typ "{keyword}" hier en verzend om de muziekstijl te verwijderen.',
            },
            sub_dance_style: 'Sub dansstijl',
            sub_music_style: 'Sub muziekstijl',
            is_favorite: 'Favoriet',
        },
        featuredEvent: 'Uitgelicht evenement',
        event_types: {
            edit: {
                plural: 'Evenementtypen bewerken',
            },
        },
        brand_types: {
            edit: {
                plural: 'Brandtypen bewerken',
            },
        },
        prof_financial_title: 'Financieel centrum',
        modoration: {
            title: 'Moderatie',
        },
        official_brands: 'Officiële brands',
        export: {
            overview: {
                title: 'Exporteren en transfers',
                subtitle: 'Exporteer alle organisaties, voor elke organisatie wordt een overdrachtslink gegenereerd.',
            },
            create: 'Creëer export',
            copied_link: 'Link gekopieerd',
            take_ownership: 'Eigendom worden',
            validate_phone:
                'Om het eigendom van deze organisatie te nemen, moet u eerst uw telefoonnummer valideren, dit kan hier hieronder worden gedaan:',
            require_login:
                'Om het eigendom van deze organisatie te nemen, moet u eerst inloggen of een account aanmaken, dit kan hier hieronder worden gedaan:',
            to_login: 'Inloggen',
            messages: {
                opened: 'Uw overdrachtslink is succesvol geactiveerd, u hebt 30 dagen om het proces te voltooien.',
                continue: 'Uw overdrachtslink is met succes heropend, voltooi het overdrachtsproces.',
                no_key: 'Er is geen sleutel verstrekt, dit kan gebeuren als u de pagina vernieuwt, u moet de oorspronkelijke link opnieuw openen.',
                not_exists: 'There currently is no transfer link for this organization.',
                expired: 'Deze link is verlopen.',
                unauthorized: 'Je bent niet gemachtigd om deze organisatieoverdracht te accepteren.',
                already_completed: 'Deze link is al voltooid en kan niet meer worden gebruikt.',
                transferred: 'De organisatie is met succes overgedragen.',
            },
            warning: {
                title: 'Verwijder overdrachtslink',
                body: 'Weet u zeker dat u deze overdrachtslink wilt verwijderen?',
            },
            status: {
                no_action: 'niet overgedragen',
                opened: 'geopend',
                completed: 'overgedragen',
                expired: 'verlopen',
            },
        },
        duplications: 'Duplicaties',
        suspend_toggle: {
            warning: {
                title: 'schakelophanging',
                body: 'Weet je zeker dat je de opschorting hiervan wilt veranderen?',
            },
        },
        take_offline: {
            warning: {
                title: 'afnemen',
                body: 'Weet u zeker dat u dit offline wilt nemen, het zal niet langer zichtbaar zijn voor gebruikers.',
            },
        },
        bring_online: {
            warning: {
                title: 'Online brengen',
                body: 'Weet je zeker dat je dit online wilt brengen? Het zal zichtbaar zijn voor gebruikers.',
            },
        },
        'carousel-image': {
            plural: 'Carrouselafbeeldingen',
            overview: {
                title: 'Carrouselafbeeldingen',
                subtitle: 'Beheer de carrouselafbeeldingen op de startpagina.',
            },
            create: {
                singular: 'Carrouselafbeelding aanmaken',
                success: 'Carrouselafbeelding succesvol aangemaakt',
                error: 'Fout bij het aanmaken van carrouselafbeelding',
            },
            delete: {
                success: 'Carrouselafbeelding succesvol verwijderd',
                error: 'Fout bij het verwijderen van carrouselafbeelding',
            },
            image: 'Afbeelding',
            visibility: 'Seconden zichtbaar',
            title: 'Titel',
            order_by: 'Sorteren op',
            warning: {
                body: 'Weet je zeker dat je deze carrouselafbeelding wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
                title: 'Carrouselafbeelding verwijderen',
            },
        },
        'beta-feature': {
            plural: 'Beta-functies',
            overview: {
                title: 'Beta-functies',
                subtitle: 'Beheer de beta-functies van de applicatie.',
                success: 'De beta-functies zijn succesvol bijgewerkt.',
                error: 'De beta-functies zijn niet bijgewerkt of opgehaald.',
            },
            key: 'Sleutel',
            name: 'Naam',
            description: 'Beschrijving',
            visible_to_admins: 'Zichtbaar voor beheerders',
            visible_to_users: 'Zichtbaar voor gebruikers',
        },
    },
    nav_headers: {
        agenda: {
            label: 'Latin Agenda',
            options: {
                all_events: 'Alle Evenementen',
                latin_festivals_and_congresses: 'Latin Festivals en Congressen',
                latin_parties_and_socials: 'Latin Partijen en Socials',
            },
        },
        dance_schools: {
            label: 'Latin Dansscholen',
            options: {
                dance_schools: 'Dansscholen',
                try_outs_and_start_courses: 'Try Outs en Start Cursussen',
                workshops_and_bootcamps: 'Workshops en Bootcamps',
                about_the_latin_dance_scene: 'Over de Latin Dance Scene',
            },
        },
        community: {
            label: 'Latin Gemeenschap',
            options: {
                teachers: 'Leraren',
                show_performers_and_teams: 'Artiesten & Teams',
                djs: "DJ's",
                live_bands: 'Live Bands',
                media_photo_video: 'Media, Foto, Video',
                mcs: "MC's",
            },
        },
        dancewear_and_shoes: {
            label: 'Latin Danskleding en Schoenen',
            options: {
                dancewear_and_shoes: 'Danskleding en Schoenen',
            },
        },
        for_professionals: {
            label: 'Voor Professionals',
            options: {
                create_a_brand: 'Hoe u een Merk kunt Maken',
                create_an_event: 'Hoe u een Evenement Maakt',
                promote_your_event: 'Hoe u uw Evenement kunt Promoten',
                professional_account_verification: 'Professionele Accountverificatie',
            },
        },
        join: {
            label: 'Word lid van LatinMap',
            options: {
                create_a_brand_or_organization: 'Maak een Merk of Organisatie',
                become_an_ambassador: 'Word een Ambassadeur',
            },
        },
        manage_and_promote: {
            label: 'Beheer en Promoten',
            options: {
                my_events: 'Mijn Evenementen',
                promote_your_event: 'Promoot uw Evenement',
            },
        },
    },
    impersonation: {
        banner: 'Je bekijkt als {name}',
        stop: 'Stop met imiteren',
    },
    menu_headers: {
        general_title: 'Algemeen',
        orders_title: 'Mijn bestellingen',
        settings_title: 'Instellingen',
        professional_title: 'Professioneel',
        prof_financial_title: 'Mijn financieel centrum',
        special_access_title: 'Speciale toegang',
        community_dashboard_title: 'Mijn ambassadeur van het Community-dashboard',
        session_title: 'Sessie',
    },
    account: {
        organization_settings_title: 'Organisatie Instellingen',
        selected_organization: 'Geselecteerde organisatie',
        my_events: 'Mijn evenementen',
        role: 'Rol',
        dashboard: 'Dashboard',
        default_filters: 'Mijn zoekopdrachten',
        login: 'Inloggen',
        logout: 'Uitloggen',
        sign_in: 'Inloggen',
        sign_up: 'Registreren',
        email_address: 'E-mailadres',
        password: 'Wachtwoord',
        password_repeat: 'Herhaal wachtwoord',
        password_reset: 'Wachtwoord herstellen',
        password_forgot: 'Wachtwoord vergeten',
        reset_password: 'Wachtwoord resetten',
        current_password: 'Huidig wachtwoord',
        change_password: 'Wachtwoord wijzigen',
        new_password: 'Nieuw wachtwoord',
        password_reset_success: 'Wachtwoord succesvol hersteld',
        forgot_password: 'Wachtwoord vergeten',
        not_a_member: 'Nog geen lid',
        i_already_have_an_account: 'Ik heb al een account',
        i_accept_the: 'Ik accepteer de',
        i_am: {
            label: 'Ik ben…',
            dancer: 'Danser',
            professional: 'Professional (organisator, dansschool, DJ, artiest…)',
        },
        newsletter_optin: 'Ik wil de LatinMap nieuwsbrief ontvangen',
        terms_and_conditions: 'algemene voorwaarden',
        first_name: 'Voornaam',
        last_name: 'Achternaam',
        postal_code: 'Postcode',
        street_number: 'Huisnummer',
        city: 'Stad',
        country: 'Land',
        preferred_language: 'Voorkeurstaal',
        date_of_birth: 'Geboortedatum',
        create: 'Account aanmaken',
        my_account: 'Mijn account',
        my_professional_dashboard: 'Mijn professionele dashboard',
        ambassador_dashboard: 'Ambassadeur Dashboard',
        my_organisations: 'Mijn organisaties & merken',
        my_organisations_description: 'Beheer je organisaties & merken',
        singular: 'account',
        phone: 'Telefoonnummer',
        phone_verification_token: 'Telefoonverificatiecode',
        name: 'Naam',
        user_name: 'Gebruikersnaam',
        resend_verification: 'Verificatie opnieuw versturen',
        update_error:
            'Bijwerken van je account is mislukt. Probeer het opnieuw of neem contact op met de ondersteuning.',
        myLatinmap: 'Mijn LatinMap',
        dancerprofile: 'Mijn Dansersprofiel',
        orders: 'Mijn bestellingen',
        phone_verification: 'Telefoonverificatie',
        submitted_leads: 'Mijn ingediende leads',
        settings: 'Instellingen',
        switch: 'Wissel naar Merk/Organisatie',
        beta_features: 'Beta-functies',
        gender: {
            singular: 'Geslacht',
            male: 'Man',
            female: 'Vrouw',
            other: 'Anders',
        },
        profile: {
            title: 'Profiel',
            description: 'Beheer je profielinformatie, wijzig je wachtwoord en meer.',
        },
        remove: {
            label: 'Account verwijderen',
            placeholder: 'Typ "verwijderen" hier en verstuur om je account te verwijderen.',
            admin_placeholder: 'Typ "verwijderen" hier en verstuur om dit account te verwijderen.',
            safeword: 'verwijderen',
            description:
                'Dit verwijdert je account en alle bijbehorende gegevens. Dit verwijdert geen organisaties en evenementen die je hebt aangemaakt. Deze actie is onomkeerbaar.',
        },
        favorites: {
            title: 'Favorieten',
            description: 'Jouw favoriete evenementen, dansscholen, enz.',
            no_favorites: 'Je hebt nog geen favorieten in deze categorie',
            plurals: {
                event: 'Evenementen',
                dancer: 'Dansers',
                dj: "DJ's",
                media: 'Media',
                brand: 'Dansschoenen, kleding, winkel',
                school: 'Dansscholen',
                venue: 'Locaties',
                club: 'Club',
                teacher: 'Docent',
                show_performers_and_teams: 'Show Performers & Teams',
                performer: 'Artiest',
                mc: 'MC',
                latin_music: 'Latijns-Amerikaanse muziek',
                event_organizer: 'Evenementenorganisator',
                organization: 'Organisaties & merken',
            },
        },
        likes: {
            title: 'Vind-ik-leuks',
            description: 'Jouw gelikete evenementen, dansscholen, enz.',
            no_likes: 'Je hebt nog geen vind-ik-leuks in deze categorie',
            plurals: {
                event: 'Evenementen',
                dancer: 'Dansers',
                dj: "DJ's",
                media: 'Media (foto, video, videobewerking)',
                brand: 'Dansschoenen, kleding, winkel',
                school: 'Dansscholen',
                venue: 'Locaties',
                club: 'Club',
                teacher: 'Docent',
                show_performers_and_teams: 'Show Performers & Teams',
                performer: 'Artiest',
                mc: 'MC',
                latin_music: 'Latijns-Amerikaanse muziek',
                event_organizer: 'Evenementenorganisator',
                organization: 'Organisaties & merken',
            },
        },
        verification: {
            phone: {
                description:
                    "Telefoonverificatie is nodig om de veiligheid en authenticiteit van gebruikers te waarborgen die toegang hebben tot het 'professionele' dashboard. Dit werkt door een verificatiecode naar je telefoon te sturen, die je moet invoeren om je identiteit te bevestigen.",
                not_verified: 'Je telefoonnummer is niet geverifieerd.',
                send_verification_text: 'Verificatiebericht verzenden',
                sent: 'Verificatiebericht verzonden',
                verified: 'Je telefoonnummer is geverifieerd.',
                verify: 'Verifieer telefoonnummer',
                step_number_help:
                    'Vul je mobiele nummer in en klik op de knop hieronder om een verificatiecode via sms te ontvangen.',
                send_cta: 'Stuur mij een code',
                sending: 'Versturen…',
                step_code_help: 'We hebben een 8-cijferige code gestuurd naar {phone}.',
                change_number: 'Nummer wijzigen',
                resend_in: 'Je kunt de code over {seconds}s opnieuw versturen',
                resend: 'Code opnieuw versturen',
                verifying: 'Verifiëren…',
                verify_cta: 'Verifieer code',
            },
        },
    },
    dashboard: {
        title: 'Dashboard',
        welcome: 'Welkom',
    },
    organizations: {
        organization_saved: 'Organisatie & Brand succesvol opgeslagen',
        containing_emoji_error:
            "Emoji's zijn niet toegestaan in de naam. Gebruik alleen letters, cijfers en toegestane speciale tekens.",
        invalid_character_error:
            'Er is een foutief teken in de naam. Gebruik alleen letters, cijfers en toegestane speciale tekens.\nInvalide karakters: ',
        overview: {
            filters: {
                option_labels: {
                    favorites: {
                        all: 'Alle',
                    },
                    organization_type: {
                        artists: 'Docenten en Artiesten',
                        all: 'Alle',
                        organizers: 'Organisator',
                        dance_schools: 'Dansschool',
                        disk_jockeys: "DJ's",
                    },
                },
            },
            no_results: {
                title: 'Geen resultaten gevonden',
                subtitle:
                    'Er zijn geen organisaties & brands gevonden die aan uw criteria voldoen. Probeer andere filters te gebruiken.',
            },
        },
        transfers: {
            overview: {
                title: 'Overdrachten',
                subtitle: 'Beheer de overdrachten van uw organisaties & brands',
                incoming_transfers: 'Inkomende overdrachten',
                outgoing_transfers: 'Uitgaande overdrachten',
                request: 'Vraag',
                offer: 'Aanbod',
                event: 'Evenement',
                organization: 'Organisatie',
            },
            status: {
                approved: 'overdracht geaccepteerd',
                pending: 'in behandeling',
                rejected: 'overdracht daalde',
            },
            create: {
                title: 'Beheer van "{organization_name}" overdragen',
                organization: 'organisatie & Brand',
                description:
                    'Hiermee draagt u het eigenaarschap van uw organisatie & Brand over aan een andere gebruiker. De gebruiker dient geregistreerd te zijn op LatinMap met hetzelfde e-mailadres.',
                reason: 'Reden',
                transfer_to: 'Overdragen aan (e-mail)',
                transfer: 'Overdragen',
                warning: 'Zodra de overdracht is geaccepteerd, kan deze niet meer worden geannuleerd.',
            },
        },
        remove: {
            label: 'Organisatie Verwijderen',
            description: 'Verwijder permanent deze organisatie en alle bijbehorende gegevens.',
            success: 'Organisatie succesvol verwijderd',
            error: 'Kon organisatie niet verwijderen',
        },
        transactions: {
            overview: {
                title: 'Transacties',
                subtitle: 'Beheer de transacties van uw organisaties & brands',
            },
        },
        create: 'Organisatie & Brand aanmaken',
        is_public_options: {
            private: 'privé',
            public: 'openbaar',
            private_warning: 'Uw organisatie is niet online zichtbaar met deze status.',
        },
        offline_preview: 'Deze organisatie staat offline en is alleen zichtbaar als voorbeeld.',
    },
    organization: {
        accepts_posts_on_behalf: 'LatinMap mag onze events toevoegen',
        accepts_posts_on_behalf_help:
            'Als onze brand stil ligt, mag LatinMap openbaar aangekondigde events onder onze naam toevoegen. Ze zijn duidelijk gemarkeerd en je kunt ze altijd aanpassen of verwijderen.',
        'on-behalf-of': 'Namens',
        'on-behalf': {
            none: 'Maak een keuze',
            me: 'Mij, ik vertegenwoordig dit merk',
            other: 'Als vertegenwoordiger van het merk',
            noone: 'Als ambassadeur van LatinMap',
        },
        transfer: {
            title: 'Eigendom overdragen',
            description:
                'Wilt u het eigendom van deze organisatie aanvragen? Vul het formulier in en dien uw verzoek in.',
            what: 'Wat wordt aangeboden?',
            submit: 'Verzoek indienen',
            name: 'Naam',
            location: 'Locatie',
            email: 'Email',
            reason: 'Reden',
            organization: 'Organisatie & brand',
            errors: {
                nameRequired: 'Naam is verplicht.',
                emailRequired: 'E-mailadres is verplicht.',
                reasonRequired: 'Reden is verplicht.',
            },
            succesfully_sent: 'Het transfer verzoek is succesvol verstuurd.',
            error_occurred: 'Er is iets fout gegaan.',
            noOrganisation:
                'U heeft nog geen organisaties. Maak eerst een organisatie aan voordat u een overdracht kunt aanvragen.',
        },
        featured: {
            title: 'Uitgelichte Dansscholen',
            subtitle:
                'Enkele van de uitgelichte, best beoordeelde dansacademies met danscursussen nu beschikbaar. Boek een les, leer dansen en geniet!',
        },
        my_favorites: {
            title: 'Mijn favorieten',
        },
        edit: {
            public_information: 'Informatie',
            customers: 'Klanten',
            events: 'Evenementen',
            tickets: 'Tickets',
            authorized_person: 'Geautoriseerde personen',
        },
        organization_detail: {
            involved: 'Betrokken',
            verification_status: {
                verified: 'Geverifieerd',
                not_verified: 'Nog niet geverifieerd',
            },
        },
        account: {
            title: 'Account',
            description: 'Beheer uw accountgegevens voor het professionele dashboard.',
            description_not_verified: 'Verifieer uw telefoonnummer om het professionele dashboard te kunnen gebruiken.',
        },
        title: 'Organisatie & Brand',
        is_public: 'is openbaar',
        publicly_visible: 'Openbaar zichtbaar',
        change_organization: 'Verander van organisatie',
        create: 'Organisatie & Brand aanmaken',
        name: 'Naam',
        name_without_dj: "Naam (zonder 'dj')",
        dj_name_tooltip: "Voer alleen de naam in. 'DJ' wordt automatisch toegevoegd.",
        email: 'E-mail',
        phone: 'Telefoonnummer',
        phone_verification_token: 'Telefoonverificatie token',
        country: 'Land',
        city: 'Stad',
        street: 'Straat',
        street_number: 'Huisnummer',
        postal_code: 'Postcode',
        type: 'Type',
        question: 'Jouw organisatie?',
        types: {
            event: 'Evenement',
            dancer: 'Danser',
            performer: 'Performer',
            teacher: 'Docent',
            show_performers_and_teams: 'Show Performers & Teams',
            dj: 'DJ',
            mc: 'MC',
            media: 'Media (foto, video, videobewerking)',
            brand: 'Dansschoenen, Kleding, Winkel',
            latin_music: 'Latijns muziek',
            event_organizer: 'Evenementen organisator',
            school: 'Dansschool',
            live_music: 'Live band/muziek',
            venue: 'Venue',
        },
        short_description: 'Korte beschrijving',
        long_description: 'Uitgebreide beschrijving',
        photos: "Foto's",
        dance_styles: 'Dansstijlen',
        music_styles: 'Muziekstijlen',
        my_brands: 'Mijn merken',
        my_brands_description: 'Beheer uw merken',
        overview: {
            title: 'Dansscholen',
            subtitle:
                'Vind de beste dansscholen bij u in de buurt. Leer dansen van de beste leraren en geniet van de beste danslessen.',
            filters: {
                organization_name: 'Organisatienaam',
                dance_styles: 'Dansstijlen',
                postal_code: 'Postcode',
                nearby_range: 'Nabij gelegen postcode suggesties bereik',
                nearby: 'Nabij gelegen suggesties',
                location: 'Waar',
                favorites: 'Favorieten',
                country_codes: 'Landcodes',
                music_styles: 'Muziekstijlen',
                ambassadors: 'Ambassadeurs',
                slidertooltip:
                    '<p><strong>De range slider past de cijfers van de ingevoerde postcode aan om het zoekgebied groter te maken.</strong></p><p>Elke stap verhoogt de postcode met 100. </p><p>Bijvoorbeeld, bij stap 1 wordt de postcode met 100 verhoogd, en bij stap 10 wordt de postcode met 1000 verhoogd.</p>',
            },
            organizers: {
                title: 'Organisatoren',
                subtitle:
                    'Vind de beste organisatoren bij u in de buurt. Geniet van de beste evenementen en festivals.',
            },
            artists: {
                title: 'Docenten en Artiesten',
                subtitle: 'Vind de beste artiesten bij u in de buurt. Geniet van de beste evenementen en festivals.',
            },
            dance_schools: {
                title: 'Dansscholen',
                subtitle:
                    'Vind de beste dansscholen bij u in de buurt. Leer dansen van de beste leraren en geniet van de beste danslessen.',
            },
            disk_jockeys: {
                title: "DJ's",
                subtitle: "Vind de beste DJ's bij u in de buurt. Geniet van de beste evenementen en festivals.",
            },
            show_performers_and_teams: {
                title: 'Show Performers & Teams',
                subtitle: 'Vind de beste artiesten bij u in de buurt. Geniet van de beste evenementen en festivals.',
            },
            teacher: {
                title: 'Docenten',
                subtitle:
                    'Vind de beste docenten bij u in de buurt. Leer dansen van de beste leraren en geniet van de beste danslessen.',
            },
            mcs: {
                title: "MC's",
                subtitle: "Vind de beste MC's bij u in de buurt. Geniet van de beste evenementen en festivals.",
            },
            live_music: {
                title: 'Live bands/muziek',
                subtitle:
                    'Vind de beste live bands en muzikanten bij u in de buurt. Geniet van de beste evenementen en festivals.',
            },
            live_performer: {
                title: 'Live Artiest',
                subtitle:
                    'Vind de beste live artiesten bij u in de buurt. Geniet van de beste evenementen en festivals.',
            },
            performer: {
                title: 'Artiest',
                subtitle: 'Vind de beste artiesten bij u in de buurt. Geniet van de beste evenementen en festivals.',
            },
            media: {
                title: 'Media (foto, video, videobewerking)',
                subtitle: 'Vind de beste fotografen en videografen bij u in de buurt.',
            },
            brand: {
                title: 'Dansschoenen, Kleding, Winkel',
                subtitle: 'Vind de beste dansschoenen en kleding bij u in de buurt. ',
            },
        },
        artists: {
            title: 'Docenten en Artiesten',
        },
        dance_schools: {
            title: 'Dansscholen',
        },
        teacher: {
            title: 'Docent',
        },
        performer: {
            title: 'uitvoerders',
        },
        show_performers_and_teams: {
            title: 'Show Performers & Teams',
        },
        disk_jockeys: {
            title: "DJ's",
        },
        organizers: {
            title: 'Organisatoren',
        },
        manage_authorized_people: {
            title: 'Manage Authorized people',
            description:
                'Beheer de bevoegde personen van de organisaties waarvan jij eigenaar bent. Bevoegde personen kunnen jouw organisatie en evenementen beheren.',
        },
        authorized_people: {
            title: 'Geautoriseerde personen',
            create: 'Geautoriseerde persoon toevoegen',
            description:
                'Manage the authorized people of your organizations. Authorized people can manage your organization and events.',
            edit: 'Bewerk geauthoriseerde persoon',
            overview: 'Geautoriseerde personen',
            not_found: 'Geautoriseerde personen niet gevonden',
        },
        mcs: {
            title: "MC's",
        },
        live_music: {
            title: 'Live bands/muziek',
        },
        live_performer: {
            title: 'Live Artiest',
        },
        media: {
            title: 'Media (foto, video, videobewerking)',
        },
        brand: {
            title: 'Dansschoenen, Kleding, Winkel',
        },
        email_authorized: 'Voer een bestaand e-mailadres in.',
    },
    ambassador: {
        profile: 'Profiel',
        my_brands: 'Mijn merken',
        verification: {
            phone: {
                description:
                    'Telefoonverificatie is nodig om de veiligheid en authenticiteit van gebruikers die toegang hebben tot het ambassadeur dashboard te waarborgen. Het werkt door een verificatiecode naar uw telefoon te sturen, die u moet invoeren om uw identiteit te bevestigen.',
            },
        },
    },
    brands: {
        create: 'Creëer merk',
        brand_saved: 'Merk opgeslagen',
        change_brand: 'Verander merk',
        edit: {
            authorized_person: 'Geauthoriseerde mensen',
        },
        posted_by_ambassador_text:
            'Dit merk is aangemaakt door een LatinMap ambassadeur, een vertrouwde community member die aan het platform bijdraagt.',
    },
    contact: {
        title: 'Contact',
        name: 'Naam',
        email: 'E-mail',
        message: 'Bericht',
        subject: 'Onderwerp',
        send: 'Verstuur',
        success: 'Bericht verzonden',
        error: 'Er is een fout opgetreden tijdens het versturen van uw bericht.',
    },
    ticketstore: {
        select_amount: 'Selecteer ticketbedrag',
        your_information: 'Uw informatie',
        total: 'Totaal',
        next: 'Volgende',
        back: 'Terug',
        checkout: 'Afrekenen',
        tickets_for: 'Tickets voor',
        ticket_types: 'Tickettypes',
        ticket: {
            starts_at: 'Begint om',
            location: 'Locatie',
            name: 'Naam',
            description: 'Beschrijving',
            tickets_sold: 'Tickets verkocht',
            actions: 'Acties',
            available: 'Beschikbaar',
            total_available: 'Totaal beschikbaar',
            price: 'Prijs',
            create: 'Ticket type aanmaken',
            edit: 'Bewerk ticket type',
            success: 'Jouw ticket type is succesvol ingediend.',
            remove_label: 'Verwijder ticket type',
            remove_description:
                'Dit zal het ticket type verwijderen met alle geassocieerde data. Deze actie is onomkeerbaar.',
        },
    },
    events: {
        owned_by_organization: 'Eigendom van organisatie {organization_name}',
        select_category: 'Selecteer een categorie',
        select_country: 'Selecteer een land',
        select_timezone: 'Selecteer een tijdzone',
        select_status: 'Selecteer een status',
        select_currency: 'Selecteer een valuta',
        select_brand_error: 'Geen brand geselecteerd',
        title: 'Evenementen',
        bring_online: 'Online brengen',
        take_offline: 'Offline halen',
        by: 'Evenementen door {organization_name}',
        create_new: 'Nieuw evenement aanmaken',
        event_saved: 'Evenement succesvol opgeslagen',
        event_published: 'Jouw evenement is nu live en zichtbaar op de evenementen pagina.',
        error_saving: 'Er is een fout opgetreden bij het opslaan van het evenement.',
        ticket_sale: {
            button: 'Koop tickets',
            field_label: 'Ticket verkoop URL',
            field_hint:
                'Directe link waar bezoekers tickets kopen of zich registreren (bijv. Eventix, Eventbrite, eigen ticketshop). Geen social media of algemene promo-link.',
            leave_title: 'Je verlaat LatinMap',
            leave_message:
                'Je staat op het punt LatinMap te verlaten en wordt doorgestuurd naar de officiële ticketpagina van de organisator.',
            proceed: 'Doorgaan',
            cancel: 'Annuleren',
            redirect_failed: 'De ticketpagina kon niet worden geopend. Probeer het opnieuw.',
        },
        containing_emoji_error:
            "Emoji's zijn niet toegestaan in de naam. Gebruik alleen letters, cijfers en toegestane speciale tekens.",
        invalid_character_error:
            'Er is een foutief teken in de naam. Gebruik alleen letters, cijfers en toegestane speciale tekens.\nInvalide karakters: ',
        duration_too_long:
            'De duur van dit evenement is te lang, het maximale aantal dagen dat een evenement mag duren is: ',
        error_updating_ticket_type: 'Er is een fout opgetreden bij het opslaan van het ticket type.',
        ticket_type_updated: 'Het tickettype is succesvol bijgewerkt.',
        posted_by_ambassador: 'Gepost door LatinMap Ambassador',
        posted_by_ambassador_text:
            'This event was created by a LatinMap Ambassador, a trusted community member contributing to platform content.',
        posted_on_behalf_text:
            'Dit event is door LatinMap toegevoegd op basis van openbaar beschikbare informatie. De organisator heeft deze eventinformatie nog niet zelf bijgewerkt.',
        posted_on_behalf_label: 'toegevoegd door LatinMap',
        // LA-202: the public pill on the event page. Separate from the
        // line above, which is appended to a title in the organiser's own
        // list and reads as a note rather than a credit.
        posted_by_latinmap: 'Geplaatst door LatinMap',
        not_posted_by_ambassador: 'Geverifieerd door organisatie & Brand',
        participants: {
            create: {
                title: 'Nieuwe deelnemer aan "{event_name}" toevoegen',
                description: 'Voeg een nieuwe deelnemer toe aan "{event_name}".',
                invite: 'Uitnodigen',
                role: 'Rol',
            },
            role: {
                performer: 'Artiest',
                organizer: 'Organisator',
            },
            overview: {
                participants: 'Deelnemers',
            },
        },
        statuses: {
            active: 'Actief',
            canceled: 'Geannuleerd',
            changed: 'Veranderd',
            pending: 'In behandeling',
        },
        currencies: {
            none: 'Geen valuta',
            euro: 'Euro',
            dollar_american: 'Amerikaanse Dollar',
            pound_uk: 'Engelse Pond',
            lira_turkish: 'Turkse Lira',
            rupee_indian: 'Indiase Roepie',
        },
        event_detail: {
            cta_block: {
                title: 'Tickets',
                subtitle: 'Er zijn tickets beschikbaar voor dit evenement!',
                button: 'Koop nu uw tickets',
            },
            organizer: {
                plural: 'Organisatoren',
                singular: 'Organisator',
                invariable: 'Organisator(s)',
            },
        },
        overview: {
            title: 'Evenementen',
            eyebrow: 'Latin Dance Agenda',
            hero_lead: 'Waar de dansvloer',
            hero_accent: 'nooit slaapt.',
            hero_lede:
                'Salsa. Bachata. Kizomba. Zouk. Elk feest, festival, workshop en social — gesorteerd op de avond dat je wilt dansen.',
            events_live: 'live events',
            week_short: 'Week',
            view: {
                list: 'Lijst',
                month: 'Maand',
            },
            nearby_events: 'Evenementen in de buurt',
            subtitle:
                'Laat u onderdompelen in het ritmische klanken, opwindende bewegingen en culturele fusie van salsa, bachata en meer. Ontdek een gevarieerd scala aan evenementen, van energieke dansfeesten tot educatieve workshops gegeven door gerenommeerde instructeurs. Of u nu een ervaren danser bent of net begint aan uw Latijns-Amerikaanse dansreis, onze website is uw ultieme gids om de meest sensationele festivals en congressen bij u in de buurt te vinden. Doe met ons mee en laat de muziek uw passie voor Latijns-Amerikaanse dans aanwakkeren!',
            festival: {
                title: 'Dansfestivals en congressen',
            },
            try_out: {
                title: 'Try-outs, Open dag, Proeflessen',
            },
            party_social: {
                title: 'Feesten & Socials',
            },
            no_results: {
                title: 'Geen resultaten gevonden',
                subtitle:
                    'Er zijn geen evenementen gevonden die aan uw criteria voldoen. Probeer andere filters te gebruiken.',
            },
            filters: {
                search_section: 'Zoeken',
                when_section: 'Wanneer',
                personal_section: 'Persoonlijk',
                where_section: 'Waar',
                styles_section: 'Categorieën & stijlen',
                refine: 'Verfijnen',
                applied: 'Actief',
                clear_all: 'Wis alles',
                event_name: 'Event of Organisatie naam',
                event_id: 'Event ID',
                event_category: 'Event type',
                dance_styles: 'Dansstijlen',
                dance_style: 'Dansstijl',
                music_styles: 'Muziekstijlen',
                music_style: 'Muziekstijl',
                ambassadors: 'Ambassadeurs',
                status: 'Status',
                user_name: 'Gebruiker',
                user_type: 'Gebruiker type',
                organization: 'Organizatie',
                organization_type: 'Organizatie type',
                location: 'Waar',
                date: 'Wanneer',
                date_from: 'Van',
                date_to: 'Tot',
                apply_filters: 'Filters vermelden',
                clear_filters: 'Filters wissen',
                country_codes: 'Landcodes',
                city: 'Stad',
                favorites: 'Favorieten',
                postal_code: 'Postcode',
                nearby_range: 'Nabij gelegen postcode suggesties bereik',
                apply: 'Toepassen',
                sliderinfo: 'Stappen van 100',
                slidertooltip:
                    '<p><strong>De range slider past de cijfers van de ingevoerde postcode aan om het zoekgebied groter te maken.</strong></p><p>Elke stap verhoogt de postcode met 100. </p><p>Bijvoorbeeld, bij stap 1 wordt de postcode met 100 verhoogd, en bij stap 10 wordt de postcode met 1000 verhoogd.</p>',
                option_labels: {
                    date_filter: {
                        upcoming: 'Aankomend',
                        this_week: 'Deze week',
                        next_week: 'Volgende week',
                        in_two_weeks: 'Over twee weken +',
                        this_month: 'Deze maand',
                        specific_dates: 'Specifieke data',
                        all: 'Alle',
                    },
                    favorites: {
                        all: 'Alle',
                        favorites: 'Toon alleen evenementen van mijn favoriete merken',
                        likes: 'Toon alleen mijn gelikete evenementen',
                        favorites_likes: 'Toon gelikete evenementen of evenementen van mijn favoriete merken',
                    },
                    organization_type: {
                        all: 'Alle',
                        organizers: 'Organisator',
                        music_styles: 'Muziekstijlen',
                        music_style: 'Muziekstijl',
                        artists: 'Artiest',
                        dance_schools: 'Dansschool',
                        disk_jockeys: "DJ's",
                    },
                    user_type: {
                        professional: 'Professioneel',
                        ambassador: 'Ambassadeur',
                        admin: 'Admin',
                        superadmin: 'Superadmin',
                    },
                },
            },
            workshop_bootcamp: {
                title: 'Workshops en Bootcamps',
            },
        },
        type: {
            festivals_and_congresses: 'Festivals & Congressen',
            try_out: 'Try-outs, Open dag, Proeflessen',
            live_music: 'Live muziek',
            workshop_bootcamp: 'Workshops & Bootcamps',
        },
        categories: {
            festival: 'Festival/Congres',
            workshop_bootcamp: 'Workshop/Bootcamp',
            workshop_bootcamp_party: 'Feest met Workshop/Bootcamp',
            party_social: 'Feest/Social',
            competition: 'Wedstrijd',
            performance_concert: 'Optreden/Concert',
            outdoor_event: 'Openlucht event',
            dance_trip: 'Dansreis',
            party_live_music: 'Feest met live muziek',
            online_event: 'Online event',
            try_out: 'Try-out, Open dag, Proefles',
            show: 'Show',
            marathon: 'Marathon',
            weekender: 'Weekender',
            retreat: 'Retreat',
            other: 'Anders',
        },
        create: 'Evenement aanmaken',
        edit: 'Evenement bewerken',
        remove: {
            label: 'Evenement verwijderen',
            description: 'Weet u zeker dat u dit evenement wilt verwijderen? Deze actie is onomkeerbaar.',
        },
        brand: 'merk/organisatie',
        name: 'Naam',
        country: 'Land',
        city: 'Stad',
        street: 'Straat',
        street_number: 'Huisnummer',
        short_description: 'Korte beschrijving',
        long_description: 'Uitgebreide beschrijving',
        social_preview_description: 'Social preview-omschrijving',
        social_preview_description_hint:
            'Optioneel. Een korte teaser (max 280 tekens) die gebruikt wordt voor de Share Link-preview wanneer het evenement wordt gedeeld op WhatsApp, Facebook of LinkedIn. Leeg gelaten wordt de korte beschrijving gebruikt.',
        share: {
            title: 'Deellink',
            copy_share_link: 'Kopieer deellink',
            share_link_help:
                'Gebruik deze link bij het delen op WhatsApp, Facebook of LinkedIn. Hij toont de juiste preview en opent de volledige eventpagina met alle informatie.',
            edit_hint: 'Deel deze link (niet het browseradres) op social media zodat je event de juiste preview toont.',
        },
        dance_styles: 'Dansstijlen',
        music_styles: 'Muziekstijlen',
        photos: "Foto's",
        photos_preview_mode: "Foto's zijn zichtbaar na opslaan in voorbeeldmodus",
        preview: 'Weergeven',
        category: 'Event Type',
        language: 'Taal',
        location_type: {
            singular: 'Locatietype',
            online: 'Virtueel',
            offline: 'Persoonlijk',
        },
        timezone: 'Tijdzone',
        date: 'Datum',
        week: 'Week',
        start: 'Start',
        end: 'Eind',
        location: 'Locatie',
        information: 'Informatie',
        start_date: 'Begindatum',
        start_time: 'Begintijd',
        end_date: 'Einddatum',
        end_time: 'Eindtijd',
        ends_at: 'Eindigt om',
        registration_opens_at: 'Registratie opent op',
        registration_closes_at: 'Registratie sluit op',
        is_public: 'Klaar om live te gaan?',
        location_name: 'Locatienaam',
        photos_required: 'Minimaal 1 foto is vereist.',
        tickets_sold: 'Tickets verkocht',
        actions: 'Acties',
        participate: 'Deelnemen',
        verified: 'Brand officiel verifieerd',
        undercondition: 'Nog niet bevestigd',
        warning: 'Belangrijke wijziging - Laatste update:',
        ticket: 'Tickets beschikbaar',
        cancelled: 'Geannuleerd - Laatste update:',
        upcoming: 'Aankomende events',
        past: 'Afgelopen events',
        status: 'Status',
        status_reason: 'Status toelichting',
        entrance: 'Ticket Prijzen',
        entrance_tooltip:
            "Hier kun je de prijs voor tickets opgeven. Vul een getal in als de prijs vast is, bijvoorbeeld '5'. Voor een prijsspreiding kun je een bereik opgeven, bijvoorbeeld '5-10'. Gebruik 'free' voor gratis toegang.",
        currency: 'Valuta',
        currency_tooltip:
            "Je kunt ook de valuta selecteren via het dropdownmenu. Veelgebruikte valuta zijn: euro (€), Amerikaanse dollar ($), Engelse pond (£), Turkse lira (₺) en Indiase roepie (₹). Als je geen valuta selecteert, kun je een vrije tekst invoeren, zoals '5-12 euro'.",
        repeat: 'Herhaling',
        djs: "DJ's",
        dj: 'DJ',
        artists: 'Artiesten',
        artist: 'Artiest',
        question: 'Jouw evenement?',
        status_options: {
            active: 'Actief',
            canceled: 'Geannuleerd',
            pending: 'Nog niet bevestigd',
            changed: 'Belangrijke wijziging',
        },
        is_public_options: {
            draft: 'Concept',
            private: 'Privé',
            public: 'Publiek',
            draft_message: 'Sla uw evenement op als concept. Het zal niet zichtbaar zijn voor het publiek.',
            private_message: 'Uw evenement is alleen zichtbaar voor gebruikers met toegang.',
            public_message: 'Publiceer uw evenement om het zichtbaar te maken op de Evenementenpagina.',
            private_warning: 'Uw evenement is niet online zichtbaar met deze status.',
        },
        legend: {
            title: 'Legenda',
            verified: 'Brand officiel verifieerd',
            not_verified:
                'Niet geverifieerd door organisatie & Brand: de organisator heeft de activiteit nog niet bevestigd.',
            cancelled: 'Geannuleerd',
            warning: 'Belangrijke wijziging',
            posted_by: 'Gepost door LatinMap Ambassador',
            condition: 'Nog niet bevestigd',
            ticket: 'Tickets beschikbaar',
            duplicate_event_error: 'Er bestaat al een evenement met deze naam, startdatum en einddatum',
            ticket_order: 'Kaartjes beschikbaar, Bestel ze hier!',
        },
        ticket_types: 'Tickettypes',
        potential_duplicates: 'Mogelijke duplicaten',
        proceed_anyway: 'Opslaan ondanks duplicaat',
        duplicate_event_error: 'Er bestaat al een evenement met deze naam, startdatum en einddatum',
        event_deleted: 'Event verwijderd',
        error_deleting_event: 'Er is een fout opgetreden tijdens het verwijderen van dit evenement',
        featured: {
            title: 'Uitgelichte evenementen in de gemeenschap',
            subtitle: 'Ontdek en koop uw tickets voor dansfestivals, concerten en uitstapjes tegen de beste prijs!',
            badge: 'Uitgelicht',
            view: 'Bekijk event',
            title_page: 'Globale prijs aanpassen',
            featured_event: 'Uitgelicht Evenement',
            duration_type: 'Looptijd Type',
            day: 'Dag',
            month: 'Maand',
            year: 'Jaar',
            duration: 'Looptijd',
            price: 'Prijs',
            calculate_price: 'Bereken Prijs',
            proceed_to_payment: 'Ga verder naar Betaling',
            current_price: 'Huidige Prijs',
            no_price_found: 'Geen prijs gevonden voor de geselecteerde looptijd',
            update_price: 'Werk Prijs Bij',
            setFeaturedEvents: 'Stel een aanbevolen evenement in',
            fetch_current_price: 'Haal Huidige Prijs Op',
            update_global_event_price: 'Werk Globale Evenement Prijs Bij',
            price_per_day: 'Prijs per dag',
            buy: 'Uitgelicht evenement kopen',
            duration_label: 'Hoe lang wilt u het evenement uitlichten?',
            enter_duration: 'Duur Selecteren',
            total_price: 'Totaal',
            yes: 'Ja',
            no: 'Nee',
            invalid_invoice: 'Er is iets foutgegaan, probeer het opnieuw',
            download_failed: 'Er is iets foutgegaan, probeer het opnieuw',
            setFeaturedEvent: 'Uitgelicht evenement instellen voor:',
            setFeatured: 'Uitgelicht evenement instellen',
            featured_success: 'Het evenement is succesvol uitgelicht.',
            already_featured: 'Dit evenement is al uitgelicht',
            featured_error: 'Er is iets fout gegaan',
            durationError: 'Waarde mag niet lager zijn dan 1',
        },
    },
    blocked_user: {
        create: 'Blokkeerde gebruiker maken',
        edit: 'Update geblokkeerde gebruiker',

        blocked_email: 'geblokkeerde e -mail',
        blocked_phone_number: 'geblokkeerd telefoonnummer',
        reason: 'Reason',

        delete: {
            warning: {
                title: 'Delete user blocking',
                body: 'Weet u zeker dat u dit blok wilt verwijderen.',
            },
        },
    },
    carousel: {
        title: 'Ontdek Latijns-Amerikaanse dans - Evenementen, scholen, try-outs en meer bij jou in de buurt!',
        subtitle: 'Ontdek waar je kunt dansen, leren en in contact kunt komen met de Latijns-Amerikaanse gemeenschap.',
        popular: 'Populair',
        search: {
            placeholder: 'Voer een trefwoord of stad in om Latijns-Amerikaanse dansopties te ontdekken...',
            button: 'ONTDEK',
        },
    },
    home: {
        // LA-179: the official Instagram strip that closes the homepage.
        instagram: {
            title: 'Live van de dansvloer',
            subtitle: 'Het laatste van onze Instagram — de scene zoals die er echt uitziet, week na week.',
            follow: 'Volg {handle}',
            post_alt: 'Een post van {handle} op Instagram',
        },
        cta_block_1: {
            title: 'Organiseert u dans-evenementen?',
            subtitle:
                'Als u feesten, festivals, uitstapjes, congressen, weekends, workshops, intensieve cursussen en dansconcerten organiseert, hebben we iets voor u. Promoot uw evenement, beheer promotors en verkoop tickets!',
            button: 'Nu aanmelden',
        },
        cta_block_2: {
            title: 'Ontdek Evenementen Bij U in de Buurt',
            subtitle: 'Ontdek evenementen en activiteiten in uw omgeving. Verken en geniet van de ervaringen!',
            placeholder: 'Uw locatie',
            input_button: 'Bij mij in de buurt',
            button: 'Vind evenementen',
        },
        cta_block_3: {
            button: 'Evenement aanmaken',
        },
        experiences_eyebrow: 'Ontdek',
        choose_and_live_experiences: 'Kies en beleef ervaringen',
        experiences_subtitle: 'Kies een sfeer en duik direct de Latin dance scene in.',
        experiences: {
            festivals_congresses: 'Festivals & Congressen',
            parties_socials: 'Feesten, Socials',
            try_outs_start_courses: 'Proeflessen, Start Cursussen',
            dance_schools: 'Dansscholen',
            workshops_bootcamps: 'Workshops, Bootcamps',
            dancewear_shoes: 'Danskleding & Schoenen',
            teachers: 'Docenten',
            show_performers_teams: 'Showartiesten & Teams',
            djs: "DJ's",
            live_music: 'Live Bands',
            media_photo_video: 'Media (Foto/Video)',
            mcs: "MC's",
        },
        cta_journey: {
            title: 'Start je LatinMap reis',
            subtitle: 'Kies hoe je LatinMap wilt ervaren',
            agenda: {
                title: 'Wereldwijde Agenda',
                sub_header: 'Gratis te bekijken',
                subtitle: 'Ontdek de wereldwijde Latin dance scene',
                description: 'Bekijk feesten, workshops, festivals, proeflessen & startcursussen - alles in één agenda',
                button: 'Bekijk Latin Agenda',
                footer: 'Geen account nodig',
            },
            member: {
                title: 'Word Lid',
                sub_header: 'Gratis account',
                subtitle: 'Bouw je eigen LatinMap ervaring',
                description:
                    'Maak je persoonlijke LatinMap en blijf verbonden met de Latin dance scene — lokaal en internationaal.',
                features: {
                    agenda: 'Complete & actuele Latin dance agenda',
                    follow: 'Volg je favoriete evenementen, artiesten & merken',
                    save: 'Sla je favorieten op met één klik',
                    store: 'Bewaar je zoekopdrachten & ontdekkingen',
                    custom_agenda: 'Maak je eigen persoonlijke agenda',
                    explore: 'Ontdek nieuwe steden, stijlen & scenes',
                },
                button: 'Maak gratis account',
                footer: 'Gratis aanmelden – mis nooit meer een evenement',
            },
            professional: {
                title: 'Word Professional',
                sub_header: 'Gratis professioneel profiel',
                subtitle: "Voor festivals, dansscholen, docenten, DJ's, muzikanten & organisatoren",
                description:
                    'Vergroot je zichtbaarheid, beheer je evenementen en bereik de internationale Latin community.',
                features: {
                    brand_page: 'Je eigen professionele merkpagina',
                    publish: 'Publiceer & beheer evenementen eenvoudig',
                    invite: 'Nodig teamleden uit om samen te werken',
                    insights: 'Inzichten, statistieken & groeitools',
                    exposure: 'Internationale exposure op LatinMap',
                },
                button: 'Activeer Pro account',
                footer: 'Vereist eerst een Lid account',
            },
        },
    },
    dropzone: {
        drop_here: 'Sleep bestanden hier om te uploaden',
        files_required: '{count} vereist',
        max_filesize: 'Maximale bestandsgrootte: {max} MB',
    },
    general: {
        select_organization_please: 'Selecteer een organisatie alstublieft',
        no_organization_selected: 'Geen organisatie geselecteerd',
        all: 'Alle',
        styles: 'Stijlen',
        important_information: 'Belangrijke informatie',
        starts_at: 'Van',
        ends_at: 'Tot',
        socialmedia_links: 'Links',
        share_with_your_friends: 'Deel met je vrienden',
        link_copied: 'Link gekopieerd naar klembord!',
        link_copy_failed: 'Kon link niet kopiëren.',
        hosted_by: 'Gehost door',
        created_by: 'Aangemaakt door',
        posted_by: 'Geplaatst door',
        created: 'Aangemaakt',
        archive: 'Archief',
        modified: 'Aangepast',
        score: 'Score',
        reset: 'resetten',
        unknown: 'Onbekend',
        submit: 'Verzenden',
        suggest: 'Voorstellen',
        back: 'Terug',
        other: 'Anders',
        delete: 'Verwijderen',
        copy_link: 'kopieerlink',
        show: 'Toon',
        duplicate: 'Dupliceren',
        proceed: 'Doorgaan',
        cancel: 'Annuleren',
        accept: 'Accepteren',
        reject: 'Afwijzen',
        checkout: 'Afrekenen',
        show_in_new_window: 'Open in nieuw venster',
        external_link_warning: {
            title: 'Externe link',
            content: 'U staat op het punt deze site te verlaten.',
            question: 'Wilt u doorgaan naar de volgende URL?',
        },
        add: 'Toevoegen',
        date: 'Datum',
        search: {
            save_new: 'Bewaar nieuwe zoekopdracht',
            instructions:
                'Bewaar uw zoekopdracht om deze later opnieuw te gebruiken. Geef uw zoekopdracht een duidelijke naam.',
            name: 'Zoekopdrachtnaam',
            none_stored: 'U heeft nog geen zoekopdrachten opgeslagen.',
            stored: 'Opgeslagen zoekopdrachten',
            events: 'Evenementen',
            organizations: 'Organisaties & brands',
            paginate: 'Per pagina',
            page: 'Pagina',
            view: 'Weergave',
            filters: 'Filters',
            delete: 'Verwijderen',
            views: {
                grid: 'Raster',
                list: 'Lijst',
                agenda: 'Agenda',
                monthlist: 'Maandlijst',
            },
            filter_labels: {
                dance_styles: 'Dansstijlen',
                music_styles: 'Muziekstijlen',
                event_categories: 'Categorieën',
                date_filter: 'Datum',
                favorites: 'Favorieten',
                country_codes: 'Landcodes',
                organization_type: 'Organisatietypes',
                location: 'Locatie',
                name: 'Naam',
            },
        },
        socials: {
            facebook: 'Facebook',
            instagram: 'Instagram',
            site: 'Website',
            linkedin: 'Linkedin',
            youtube: 'Youtube',
            tiktok: 'Tiktok',
            reddit: 'Reddit',
            pinterest: 'Pinterest',
            twitter: 'X',
            spotify: 'Spotify',
            soundcloud: 'SoundCloud',
            facebook_event: 'Facebook-evenement',
            whatsapp: 'WhatsApp',
        },
        description: {
            title: 'Beschrijving',
            show_more: 'Meer tonen',
            show_less: 'Minder tonen',
        },
        map: 'Kaart',
        gmap_block: {
            title: 'Kaart',
            location_name: 'Locatienaam',
        },
        spotify_block: {
            title: 'Spotify',
        },
        soundcloud_block: {
            title: 'SoundCloud',
        },
        paginate: {
            results: 'Resultaten',
            filter: 'Filter',
            open_filter: 'Filter openen',
            page: 'pagina',
        },
        edit: 'Bewerken',
        create: 'Aanmaken',
        expand: 'Meer',
        more_info: 'Meer informatie',
        collapse: 'Minder',
        unique_impressions: 'Unieke impressies',
        close: 'Sluiten',
        save_changes: 'Wijzigingen opslaan',
        update_changes: 'Wijzigingen opslaan',
        scrollright: 'Scroll naar rechts voor meer gegevens.',
    },
    header: {
        title: 'LatinMap',
        quote: 'De hartslag van de Latin dance scene',
        navigation: 'Navigatie',
        cta: 'Evenement aanmaken',
    },
    date: {
        from: 'Van',
        to: 'Tot',
    },
    report: {
        event: 'Rapporteer Evenement',
        organization: 'Rapporteer Organisatie',
        name: 'Naam',
        location: 'Locatie',
        date: 'Datum',
        success: 'Uw rapport is succesvol ingediend.',
        not_logged_in: 'Account vereist',
        tooltip: 'Rapporteer',
        status: {
            warning: {
                title: 'Wijzig raport status',
                body: 'Weet je zeker dat je de raport status wilt wijzigen van dit raport?',
            },
        },
        archive: {
            warning: {
                title: 'archiefrapport',
                body: 'Weet u zeker dat u dit rapport wilt archiveren? Dit kan niet ongedaan worden gemaakt.',
            },
        },
    },
    form: {
        save: 'Opslaan',
        save_and_verify: 'Opslaan en verifiëren',
        too_many_requests:
            'U hebt de berichtenlimiet bereikt. ' + 'Wacht een paar minuten voordat u een nieuw verzoek verstuurt.',
    },
    form_subject: {
        general_inquiry: 'Algemene Vraag',
        technical_support: 'Technische Ondersteuning',
        issue_event_submission: 'Evenement Inzending Probleem',
        issue_account_login: 'Account of Inlog Probleem',
        question_billing_payment: 'Facturate of Betalings Vraag',
        report_issue: 'Rapporteer een probleem',
        suggest_feature: 'Functie Suggestie',
        other: 'Anders',
    },
    api: {
        general: {
            validation_error: 'Validatiefout',
            permission_denied: 'Toestemming geweigerd',
            success: 'succes',
        },
        auth: {
            unauthorized: 'U bent niet gemachtigd om deze bron te raadplegen.',
            blocked: 'Uw account is geblokkeerd, u hebt geen toegang tot functies.',
            user_not_found: 'Een account is verplicht om deze functionaliteit te gebruiken, maak eerst een account.',
            email_password_unknown: 'Het opgegeven e-mailadres of wachtwoord is onjuist.',
            email_unverified: 'Uw e-mailadres is niet geverifieerd.',
            email_already_verified: 'Uw e-mailadres is al geverifieerd.',
            phone_already_verified: 'Uw telefoonnummer is al geverifieerd.',
            phone_already_used: 'Dit telefoonnummer is al in gebruik',
            invalid_verification_link: 'De opgegeven verificatielink is ongeldig.',
            email_verified_success: 'Uw e-mailadres is geverifieerd. Je word automatisch doorgestuurd.',
            verification_email_sent: 'Er is een verificatielink naar uw e-mailadres gestuurd.',
            login_success: 'U bent succesvol ingelogd.',
            logout_success: 'U bent succesvol uitgelogd.',
            registration_success:
                'U bent succesvol geregistreerd. Er is een verificatielink naar uw e-mailadres gestuurd.',
            failed: 'Deze referenties komen niet overeen met onze gegevens.',
            password: 'Het opgegeven wachtwoord is onjuist.',
            throttle: 'Te veel inlogpogingen. Probeer het over :seconds seconden opnieuw.',
            user_updated_success: 'Uw profiel is succesvol bijgewerkt.',
            old_password_incorrect: 'Het oude wachtwoord is onjuist.',
            password_changed_success: 'Uw wachtwoord is succesvol gewijzigd.',
            user_deleted_success: 'Uw account is succesvol verwijderd.',
            verification_text_sent: 'Er is een verificatiecode naar uw telefoonnummer gestuurd.',
            invite_invalid: 'De uitnodiging is ongeldig.',
            too_many_requests: 'Te veel aanvragen. Probeer het later nog een keer.',
            day_limit_exceeded:
                'U hebt vandaag de maximale hoeveelheid verzoeken voor deze functionaliteit overtroffen.',
        },
        organization: {
            created_success: 'De organisatie & Brand is succesvol aangemaakt.',
            authorized_person: {
                created: 'De geautoriseerde persoon is succesvol aangemaakt.',
                updated: 'De geautoriseerde persoon is succesvol bijgewerkt.',
                removed: 'De geautoriseerde persoon is succesvol verwijderd.',
                not_found: 'De geautoriseerde persoon is niet gevonden.',
                already_exists: 'De geautoriseerde persoon bestaat al.',
                role: {
                    singular: 'Rol',
                    invalid: 'De opgegeven rol is ongeldig.',
                    eventPublisher: 'Event uitgever',
                    eventCreator: 'Eventmaker',
                    authorizedPerson: 'Geautoriseerde persoon',
                },
            },
        },
        event: {
            created_success: 'Het evenement is succesvol aangemaakt.',
            deleted_success: 'Het evenement is succesvol verwijderd.',
        },
        report: {
            created_success: 'Het rapport is succesvol aangemaakt.',
            invalid_type: 'Het opgegeven rapporttype is ongeldig.',
        },
        user: {
            updated_success: 'De gebruiker is succesvol bijgewerkt.',
            search_filter: {
                created: 'Aangemaakt',
            },
        },
        upload: {
            created_success: 'De upload is succesvol aangemaakt.',
            deleted_success: 'De upload is succesvol verwijderd.',
        },
        forms: {
            submitted_success: 'Het formulier is succesvol ingediend.',
        },
        passwords: {
            reset: 'Uw wachtwoord is gereset.',
            sent: 'We hebben uw wachtwoordresetlink gemaild!',
            throttled: 'Wacht even voordat u het opnieuw probeert.',
            token: 'Deze wachtwoordreset-token is ongeldig.',
            user: 'We kunnen geen gebruiker vinden met dat e-mailadres.',
        },
        pagination: {
            previous: '&laquo; Vorige',
            next: 'Volgende &raquo;',
        },
        dance_style: {
            saved_success: 'Dansstijl is succesvol opgeslagen.',
            deleted_success: 'Dansstijl is succesvol verwijderd.',
            deleted_error: 'Er is een fout opgetreden bij het verwijderen van het dansstijl.',
            not_found: 'Dansstijl is niet gevonden.',
            parent_not_found: 'Hoofd dansstijl is niet gevonden.',
            suggest_success: 'Dansstijl suggestie verzonden',
        },
        music_style: {
            saved_success: 'Muziekstijl is succesvol opgeslagen.',
            deleted_success: 'Muziekstijl is succesvol verwijderd.',
            not_found: 'Muziestijl is niet gevonden.',
            parent_not_found: 'Hoofd muziekstijl is niet gevonden.',
            suggest_success: 'Muziekstijl suggestie verzonden',
        },
        invite: {
            sent: 'Uitnodiging verzonden',
            removed: 'Uitnodiging verwijderd',
            resend_success: 'Uitnodiging opnieuw verzonden',
        },
        transfer_request: {
            already_owner: 'U bent al de eigenaar van deze organisatie',
            organization_already_owns_event: 'De organisatie is al eigenaar van dit evenement',
        },
        transferlink: {
            removed: 'De transferlink is verwijderd.',
        },
        user_block: {
            create_success: 'Gebruikersblok is succesvol gemaakt.',
            update_success: 'Gebruikersblok is succesvol bijgewerkt.',
            delete_success: 'Gebruikersblok is succesvol verwijderd.',
        },
    },
    favorites: {
        favorite: 'Favoriet',
        like: 'Leuk',
        login_required: 'Je moet ingelogd zijn om dit aan je favorieten toe te voegen',
    },
    likes: {
        login_required: 'Je moet ingelogd zijn om dit aan je likes toe te voegen',
    },
    ticketing: {
        stats: {
            title: 'Ticketkliks',
            loading: 'Statistieken laden',
            error: 'Kon de statistieken niet laden.',
            empty: 'Nog geen ticketkliks geregistreerd.',
            total: 'Totaal',
            this_month: 'Deze maand',
            last_12_months: 'Laatste 12 maanden',
            per_month: 'Per maand',
            top_events: 'Populairste events',
            by_device: 'Per apparaat',
            by_destination: 'Per bestemming',
            device: {
                mobile: 'Mobiel',
                desktop: 'Desktop',
                tablet: 'Tablet',
                unknown: 'Onbekend',
            },
            destination: {
                external: 'Extern',
                internal: 'LatinMap',
            },
        },
        internal: {
            toggle_label: 'Interne ticketing (LatinMap ticketshop)',
            toggle_hint:
                'Indien aan, openen de "Koop Tickets"-knoppen van deze brand de eigen LatinMap ticketshop in plaats van de externe URL van de organisator (alleen voor events met tickettypes).',
            updated: 'Instelling interne ticketing opgeslagen.',
            update_failed: 'Kon de instelling interne ticketing niet opslaan.',
        },
    },
    validations: {
        validations: {
            doesnt_exist: {
                'owner id': 'kon de gebruiker niet vinden om deze organisatie te maken namens.',
            },
        },
        on_behalf_of: {
            required: 'Het veld namens is verplicht.',
        },
        required: 'Dit veld is verplicht.',
        phone: {
            required: 'Het telefoonnummer is verplicht.',
            regex: 'Het telefoonnummer is ongeldig.',
            length: 'Het telefoonnummer moet minimaal 10 cijfers bevatten.',
        },
        'phone number': {
            required: 'Het telefoonnummer is verplicht.',
            regex: 'Het telefoonnummer is ongeldig.',
            'not-unique': 'Dit telefoonnummer is al in gebruik.',
        },
        number: {
            required: 'Het nummer is vereist.',
            invalid: 'Het nummer is ongeldig.',
        },
        email: {
            required: 'Het e-mailadres is verplicht.',
            invalid: 'Het e-mailadres is ongeldig.',
            'not-unique': 'Het e-mailadres is niet uniek.',
        },
        name: {
            required: 'De naam is verplicht.',
            max_length: 'De naam is te lang. Maximaal 60 tekens toegestaan.',
        },
        username: {
            required: 'De gebruikersnaam is verplicht',
            invalid: 'De gebruikersnaam is ongeldig',
        },
        first_name: {
            required: 'De voornaam is verplicht.',
        },
        last_name: {
            required: 'De achternaam is verplicht.',
        },
        gender: {
            required: 'Het geslacht is verplicht.',
        },
        city: {
            required: 'De stad is verplicht.',
        },
        street: {
            required: 'De straat is verplicht.',
        },
        street_number: {
            required: 'Het huisnummer is verplicht.',
        },
        country: {
            required: 'Het land is verplicht.',
        },
        brand: {
            required: 'Het merk is vereist.',
        },
        short_description: {
            required: 'Een korte beschrijving is verplicht.',
        },
        long_description: {
            required: 'Een uitgebreide beschrijving is verplicht.',
        },
        description: {
            required: 'Een beschrijving is verplicht.',
        },
        type: {
            required: 'Het type is verplicht.',
        },
        message: {
            required: 'Het bericht is verplicht.',
        },
        date_of_birth: {
            required: 'De geboortedatum is verplicht.',
            regex: 'De geboortedatum is ongeldig.',
            age: 'U moet minimaal 18 jaar oud zijn.',
            old: 'U mag maximaal 120 jaar oud zijn.',
        },
        date: {
            required: 'De datum is verplicht.',
            regex: 'De datum is ongeldig.',
        },
        postal_code: {
            required: 'De postcode is verplicht.',
            length: 'De postcode moet minimaal 4 cijfers bevatten.',
        },
        entrance: {
            required: 'De Ticket Prijzen zijn verplicht.',
        },
        repeat: {
            required: 'De herhaling is verplicht.',
        },
        password: {
            required: 'Het wachtwoord is verplicht.',
            regex: 'Geldig wachtwoord vereist. Minimaal 8 tekens, minstens één hoofdletter, één kleine letter en één cijfer.',
            confirmed: 'De wachtwoordbevestiging komt niet overeen.',
            mismatch: 'Het wachtwoord komt niet overeen.',
        },
        conditions: {
            required: 'U moet de algemene voorwaarden accepteren.',
        },
        url: {
            required: 'De URL is verplicht.',
            regex: 'De URL is ongeldig.',
        },
        event_category: {
            required: 'Het event type is verplicht.',
        },
        language_code: {
            required: 'De taal is verplicht.',
        },
        timezone: {
            required: 'De tijdzone is verplicht.',
        },
        is_public: {
            required: 'De zichtbaarheid is verplicht.',
        },
        form_subject: {
            required: 'Het onderwerp is verplicht.',
        },
        starts_at: {
            required: 'De startdatum is verplicht.',
            regex: 'De startdatum is ongeldig.',
        },
        start_date: {
            required: 'De startdatum is verplicht.',
            regex: 'De startdatum is ongeldig.',
            after_end_date: 'De startdatum moet voor de einddatum liggen.',
        },
        start_time: {
            required: 'De starttijd is verplicht.',
            regex: 'De starttijd is ongeldig.',
        },
        end_date: {
            required: 'De einddatum is verplicht.',
            regex: 'De einddatum is ongeldig.',
            before_start_date: 'De einddatum moet na de startdatum liggen.',
        },
        end_time: {
            required: 'De eindtijd is verplicht.',
            regex: 'De eindtijd is ongeldig.',
        },
        ends_at: {
            required: 'De einddatum is verplicht.',
            regex: 'De einddatum is ongeldig.',
            before_start_date: 'De einddatum moet na de startdatum liggen.',
        },
        registration_opens_at: {
            required: 'De registratie begint op is verplicht.',
            regex: 'De registratie begint op is ongeldig.',
        },
        registration_closes_at: {
            required: 'De registratie eindigt op is verplicht.',
            regex: 'De registratie eindigt op is ongeldig.',
        },
        location_type: {
            required: 'Het locatietype is verplicht.',
        },
        location_name: {
            required: 'De locatienaam is verplicht.',
        },
        dance_styles: {
            required: 'De dansstijlen zijn verplicht.',
        },
        music_styles: {
            required: 'De muziekstijlen zijn verplicht.',
        },
        photos: {
            required: 'Minimaal 1 foto is vereist.',
        },
        status: {
            required: 'De status is verplicht.',
        },
        string: {
            required: '{fieldname} is vereist.',
            mismatch: '"{input}" komt niet overeen met "{safeword}".',
        },
        role: {
            required: 'De rol is verplicht.',
        },
        favorite: {
            required: 'Het favoriet veld is verplicht.',
        },
        dance_style: {
            required: 'De dansstijl is verplicht.',
        },
        instagram: {
            required: 'De Instagram link is verplicht.',
            regex: 'Voer een geldige Instagram-link in.',
        },
        tiktok: {
            required: 'De TikTok link is verplicht.',
            regex: 'Voer een geldige TikTok-link in.',
        },
        website: {
            required: 'De website link is verplicht.',
            regex: 'Voer een geldige website-link in.',
        },
        facebook: {
            required: 'De Facebook link is verplicht.',
            regex: 'Voer een geldige Facebook-link in.',
        },
        facebook_event: {
            required: 'De Facebook-evenement link is verplicht.',
            regex: 'Voer een Facebook-evenement URL in — moet verwijzen naar facebook.com/events/{id}.',
        },
        youtube: {
            required: 'De videolink is verplicht.',
            regex: 'Voer een geldige YouTube- of Vimeo-link in.',
        },
        ticket_url: {
            required: 'De ticket verkoop URL is verplicht.',
            regex: 'Voer een geldige ticket-URL in die begint met http:// of https://.',
            social_not_allowed:
                'Dit moet een ticket- of registratielink zijn, geen social media of algemene promo-URL.',
        },
        linkedin: {
            required: 'De LinkedIn link is verplicht.',
            regex: 'Voer een geldige LinkedIn-link in.',
        },
        twitter: {
            required: 'De X link is verplicht.',
            regex: 'Voer een geldige X-link in.',
        },
        spotify: {
            required: 'De Spotify URI is verplicht.',
            invalid: 'Voer aub een geldige Spotify-link in in het juiste formaat.',
            regex: 'Voer aub een geldige Spotify-link in in het juiste formaat.',
        },
        soundcloud: {
            required: 'De SoundCloud-link is verplicht.',
            invalid: 'Voer aub een geldige SoundCloud-link in in het juiste formaat.',
            regex: 'Voer aub een geldige SoundCloud-link in in het juiste formaat.',
        },
        doesnt_exist: {
            email: 'E-mail adres bestaat niet.',
            user: 'Gebruiker bestaat niet.',
        },
        djs: {
            required: "DJ's zijn verplicht.",
        },
        artists: {
            required: 'Artiesten zijn verplicht.',
        },
        reason: {
            required: 'The reason is required.',
        },
        default: {
            doesnt_exist: {
                email: 'E-mail adres bestaat niet.',
                user: 'Gebruiker bestaat niet.',
            },
        },
    },
    brand_activity: {
        by_brand: 'brand-gebruiker',
        by_admin: 'admin/scraping',
        export: 'Exporteer CSV',
    },
    paginatable: {
        headers: {
            is_dancer: 'Danser',
            is_professional: 'Professional',
            newsletter_optin: 'Nieuwsbrief',
            last_event_start_date: 'Laatste eventdatum',
            last_event_at: 'Laatste eventactiviteit',
            last_event_by: 'Laatste event door',
            has_upcoming: 'Komende gepubliceerd',
            id: 'ID',
            brand_id: 'Merk ID',
            title: 'Titel',
            slug: 'Slug',
            group: 'Groep',
            email: 'E-mail',
            phone: 'telefoonnummer',
            name: 'Naam',
            first_name: 'Voornaam',
            last_name: 'Achternaam',
            role_name: 'Rol',
            role: 'Rol',
            report: 'Rapport',
            created_at_formatted: 'Aangemaakt op',
            status: 'Status',
            actions: 'Acties',
            type: 'Type',
            to_user_email: 'Naar e-mail',
            from_user_email: 'Van e-mail',
            reason: 'Reden',
            organization_name: 'Organisatienaam',
            organization_created: 'Organisatie gecreëerd',
            organization_updated: 'organisatie voor het laatst bijgewerkt',
            confirmed_at: 'Bevestigd op',
            organization_role: 'Rol',
            sub_dance_styles: 'Sub dansstijlen',
            sub_music_styles: 'Sub muziekstijlen',
            city: 'Stad',
            created_at: 'Aangemaakt op',
            updated_at: 'Bijgewerkt op',
            is_favorite: 'Favoriet',
            starts_at: 'Begint om',
            tickets_sold: 'Tickets verkocht',
            available_tickets: 'Beschikbare tickets',
            user_id: 'Account-ID',
            transferable_type: 'Type',
            content_name: 'Titel',
            paynl_transaction_id: 'PayNL transactie',
            date: 'Aankoopdatum',
            amount: 'Totaalbedrag',
            tax_amount: 'Belasting',
            currency: 'Valuta',
            description: 'Omschrijving',
            valid_from: 'Ingangsdatum',
            valid_until: 'Vervaldatum',
            items: 'Items',
            total: 'Totaal',
            price: 'Prijs',
            start_date: 'Start datum',
            is_public: 'Gepubliceerd',
            featured: 'Uitgelicht',
            created_by: 'Gebruiker',
            user_type: 'Gebruikerstype',
            user_email: 'Gebruikers e-mail',
            location_type: 'Locatie type',
            category_id: 'Categorie',
            organization_category_id: 'Categorie',
            country_code: 'Landcode',
            location: 'Locatie',
            info: 'Gebruiker informatie',
            owner: 'Names',
            adres: 'Adres',
            export_created: 'Export gemaakt',
            image_path: 'Afbeeldingspad',
            order_by: 'Sorteren op',
            visibility: 'Zichtbaarheid',
            image_alt: 'Alternatieve tekst',
            image_title: 'Afbeeldingstitel',
            image: 'Afbeelding',
            public_status: 'Openbaar status',
            country: 'Land',
            activity: 'Activiteit',
        },
        search: 'Zoeken',
        no_records: 'Geen resultaten gevonden',
    },
    pages: {
        related: "Gerelateerde pagina's",
        contact: {
            title: 'Contact Latinmap',
            body: 'Voor vragen gerelateerd aan evenementen, neem a.u.b. contact op met de organisatie & Brand die het evenement heeft geplaatst. Heeft u vragen of opmerkingen over het platform? Neem contact met ons op via het onderstaande formulier.',
        },
        'how-it-works': {
            title: 'Hoe werkt het',
            body: "<p>Online ticketverkoop via LatinMap.com</p><p>We bieden organisaties de mogelijkheid vanonline kaartverkoop. Daarbij zijn ervoor de organisaties in basis geen kosten. Bij 2 of meer tussentijdseuitbetalingen, brengen we wel kosten in rekening.</p><p><br/>&nbsp;</p><p>Goede telefonische ondersteuning voorkaartkopers en organisaties</p><p>We zijn binnen en buiten kantoor urentelefonisch bereikbaar voor vragen vankaartkopers en organisaties, 7 dagen in de week.</p><p>Hoe werkt het voor de organisatie & Brand:</p><p>-we maken voor het event een ticketlink aan.Organisaties & brands die gebruik maken vanons&nbsp;<u>Dashboard</u>&nbsp;kunnen zelf nieuwe tickets aanmakenviahet&nbsp;<u>Dashboard</u>.<br/>-standaard wordt de kaartkoper een fee van1,49 euro per aankoop (max 10kaarten) in rekening gebracht bij betaling met iDeal.<br/>-organisaties kunnen ervoor kiezen om de aankoop fee voor eigen rekening tenemen<br/>-er kunnen groepstickets worden aangemaakt<br/>-aan de ticketverkoop kan een einddatum en eindtijd worden ingesteld<br/>-ticketprijzen kunnen per periode worden ingesteld<br/>-via een beheerlink kunnen organisaties de actuele stand van zaken bekijken rondde verkoop<br/>-bij elke ticketverkoop ontvangt de organisaties daarvan een copy e-mail. Ditticket kan worden doorgestuurd naar een koper die melding maakt dat deticketmail niet is ontvangen<br/>-via het Dashboard kunnen gratis gastenlijstkaarten worden uitgegeven<br/>-via het Dashboard kunnen gratis kassakaarten worden uitgegeven. Deze kunnenhandmatig worden verkocht<br/>-er kan een maximum aan het aantal verkoopbare kaarten per ticket of het eventworden ingesteld<br/>-bij ticketverkoop kan gebruik worden gemaakt van kortingscodes<br/>-de organisaties kan gebruik maken van uitbetaling na het event, in dit gevalbieden we een annuleringsgarantie: bij het cancellen van het event, betaaltLatinMap.com de kaartkopers terug<br/>-bij annulering en restitutie door LatinMap.com worden geen kosten in rekeninggebracht (bij 1,49 per aankoop of 1 euro per ticket)<br/>-de organisaties kan ook tussentijdse uitbetaling ontvangen. In dat geval biedenwe geen annuleringsgarantie<br/>-voor elke tweede of meerdere tussentijdse uitbetaling, wordt 10 euro peruitbetaling in rekening gebracht.<br/>-de ticketverkoop wordt via onze nieuwsbrief en het Latin-Magazine maandelijksbij zo'n 10.000 mensen onder de aandacht gebracht.</p><p>Ticket handling</p><p>Tickets kunnen worden gescand met eenmobieletelefoon met de&nbsp;<u>TicketScan App voor Android</u>&nbsp;in Google Play Store. De&nbsp;<u>TicketScan App voor iOS</u>&nbsp;is beschikbaar in de App Store vanApple.<br/>Tickets kunnen online worden verwerkt. De url hiervoor is terug te vinden in hetDashboard.<br/>Van de verkochte tickets kan een csv export bestand worden gedownload die kanworden geprint of worden ingelezen in Excel.</p><p>Hoe werkt het voor de kaartkopers:</p><p>-kaartkopers kunnen online betalen metiDeal,Bancontact, PayPal, CreditCard,Sofortbanking<br/>-kaartkopers betalen een vaste fee per aankoop via iDeal/Bancontact, ongeachthet aantal kaarten. Bij andere betaalmethodes is de fee afhankelijk van hetaankoopbedrag.<br/>-kaartkopers betalen een vaste fee per ticket via iDeal/Bancontact. Bij anderebetaalmethodes is de fee afhankelijk van het aankoopbedrag.<br/>-na betaling worden de ticket(s) via de mail toegezonden<br/>-kaartkopers kunnen kiezen uit de Nederlandse en Engelse taal voor het bestellenvan tickets<br/>-via de betaalpagina kunnen kaartkopers opnieuw hun ticket(s) via de mail oplaten sturen</p>",
        },
        'goods-and-services': {
            title: 'Goods and Services',
            body: "<p>LatinMap.com: Ontdek en Beleef de Latin Danswereld</p><p>Welkom bij LatinMap.com, d&eacute; bestemming waar je moeiteloos toegang krijgt tot demeest opwindende evenementen en ervaringen in de wereld van Latin dans. Of je nu eengepassioneerde dansliefhebber bent, een beginnende danser die de eerste stappen wilzetten, of gewoonweg wilt genieten van de betoverende ritmes van Salsa, Bachata,Kizomba, Zouk en meer, onze uitgebreide dansagenda heeft voor ieder wat wils.</p><p>Met LatinMap.com bieden we een breed scala aan activiteiten, vari&euml;rend van feesten,festivals en workshops tot bootcamps, lessen en dansscholen. Of je nu wilt stralen op dedansvloer tijdens een levendig Salsa-feest, de sensuele bewegingen van Bachata wiltontdekken, de romantiek van Kizomba wilt ervaren, of de verleidelijke klanken van Zoukwilt omarmen, onze dansagenda heeft het allemaal.</p><p>Daarnaast geven we je de mogelijkheid om je favoriete organisatoren, DJ's, dansscholenen artiesten te volgen. Blijf op de hoogte van hun nieuwste evenementen en optredens, enmis nooit meer een kans om te genieten van hun unieke stijlen en talenten. Ontdek nieuweartiesten en verrijk je Latin danservaring met de diversiteit en creativiteit die deLatin dansgemeenschap te bieden heeft.</p><p>Met onze intu&iuml;tieve en gebruiksvriendelijke interface kun je moeiteloos door dedansagenda navigeren en jouw favoriete evenementen selecteren. Of je nu een ervarendanser bent die zijn techniek wil verfijnen, of iemand die gewoonweg wil genieten van deopwindende sfeer van Latin dans, LatinMap.com staat voor je klaar.</p><p>We streven naar een naadloze gebruikerservaring en bieden uitstekende ondersteuning bijvragen of eventuele problemen die je tegenkomt. Ons toegewijde team van professionalsstaat klaar om je te helpen en ervoor te zorgen dat je dansbeleving zonder hindernissenverloopt.</p><p>Ontdek, beleef en maak herinneringen met LatinMap.com. We geloven dat toegang tot demeest opwindende Latin dansevenementen jouw danspassie verrijkt en je de mogelijkheidbiedt om te groeien en te genieten van de rijke Latijnse danscultuur. Laat ons jebegeleiden op jouw reis naar onvergetelijke danservaringen.</p>",
        },
        'terms-and-conditions': {
            title: 'Algemene Voorwaarden',
            body: "<p> 20230529 Algemene voorwaarden ticketverkoop </p><p> 1. Definities </p><p> De hierna met een beginhoofdletter aangeduide begrippen hebben in deze Algemene Voorwaarden de volgende betekenis:<br/> a. Algemene Voorwaarden: deze algemene ticketverkoop voorwaarden van Stichting LatinMap.com<br/> b. Evenement: de georganiseerde gebeurtenis, zoals een gebeurtenis van muzikale, culturele, sportieve en/of recreatieve aard, waarvoor Stichting LatinMap.com Tickets verkoopt<br/> c. Evenementhouder: de natuurlijke of rechtspersoon die een Evenement produceert of organiseert en daarvoor verantwoordelijk is<br/> d. Klant: de natuurlijke of rechtspersoon met wie Stichting LatinMap.com een overeenkomst aangaat betrekking hebbend op een Evenement, dan wel aan wie Stichting LatinMap.com daartoe een aanbieding doet<br/> e. Overeenkomst: de overeenkomst tussen Stichting LatinMap.com en Klant ter verkrijging van Tickets voor Evenementen<br/> f. Ticket: het document dat dient als toegangsbewijs voor een Evenement, waaronder mede begrepen elektronische Tickets </p><p> 2. Toepasselijkheid </p><p> a. Deze Algemene Voorwaarden zijn van toepassing op alle aanbiedingen van, bestellingen bij, rechtsbetrekkingen en overeenkomsten waarbij Stichting LatinMap.com, producten of diensten van welke aard ook aan Klant levert, ook indien deze producten of diensten niet (nader) in deze Algemene Voorwaarden zijn omschreven.<br/> b. De toepasselijkheid van andere voorwaarden van Klant wijst Stichting LatinMap.com uitdrukkelijk van de hand.<br/> c. Partijen kunnen alleen schriftelijk wijzigingen ten opzichte van de Algemene Voorwaarden overeenkomen. Stichting LatinMap.com is gerechtigd de Algemene Voorwaarden te wijzigen en gewijzigde algemene voorwaarden van toepassing te verklaren op Overeenkomsten. De gewijzigde algemene voorwaarden zijn op de website van Stichting LatinMap.com raadpleegbaar. d. Op de Overeenkomst zijn van toepassing de algemene voorwaarden van de Evenementhouder van het Evenement. Indien nog niet in het bezit van Klant, zal de Evenementhouder op verzoek de algemene voorwaarden van de Evenementhouder toezenden. </p><p> 3. Totstandkoming overeenkomst </p><p> a. Tenzij schriftelijk anders is overeengekomen zijn alle aanbiedingen, daaronder begrepen advertenties en prijslijsten zoals vermeld op de website van Stichting LatinMap.com vrijblijvend. b. Stichting LatinMap.com treedt bij het aanbieden en verkopen van Tickets op als bemiddelaar bij de totstandkoming van de Overeenkomst tussen Koper en Evenementhouder. Stichting LatinMap.com is geen partij bij de Overeenkomst die tot stand komt door de aankoop van een Ticket. De Overeenkomst komt tot stand nadat Klant via Stichting LatinMap.com een of meerdere Tickets heeft gekocht. Stichting LatinMap.com verschaft de Tickets namens Evenementhouder.<br/> c. Klant dient voordat hij zijn reservering bevestigt altijd goed te controleren of de juiste Tickets zijn gereserveerd. Klant dient bij het maken van de reservering altijd een juist (e- mail)adres te gebruiken. Indien Klant kiest voor het via elektronische weg ontvangen van Tickets, berust het risico voor verlies, diefstal of misbruik van het Ticket bij Klant vanaf het moment dat de Tickets hem hebben bereikt. Als wordt getwijfeld aan de juistheid van de gegevens die Klant heeft ingevoerd bij de bestelling, kan Stichting LatinMap.com contact met Klant opnemen met behulp van de gegevens die Klant heeft ingevoerd. Als Stichting LatinMap.com Klant niet kan bereiken en de gegevens derhalve niet kan controleren, kan Stichting LatinMap.com ertoe overgaan de reservering te annuleren en de Tickets alsnog te verkopen aan een andere Klant. Indien Stichting LatinMap.com twijfelt aan de juistheid of de geldigheid van de door de Klant bij de bestelling ingevoerde gegevens of het door de Klant gebruikte betaalmiddel, dan heeft zij het recht om de reservering van de Klant te annuleren en de Tickets alsnog te verkopen aan een andere Klant. Stichting LatinMap.com zal zich inspannen om de Klant in een dergelijk geval te informeren. Iedere Overeenkomst wordt aangegaan onder de opschortende voorwaarde van voldoende beschikbaarheid van de desbetreffende producten of diensten.<br/> d. Stichting LatinMap.com en/of de Evenementhouder behouden zich het recht voor om een maximum te stellen aan het aantal te reserveren/kopen Tickets. Bij een overschrijding van dit maximum door de Klant, is Stichting LatinMap.com en/of de Evenementhouder gerechtigd om de reservering van de Tickets boven het maximum aantal ongedaan te maken of de betreffende Tickets ongeldig te maken.<br/> e. Tickets kunnen niet worden geretourneerd. Het bepaalde in artikel 6:230p sub e BW is van toepassing op tickets. </p><p> 4. Prijzen en betaling </p><p> a. Stichting LatinMap.com verkoopt Tickets namens Evenementhouders die de prijs en het aantal beschikbare plaatsen bepalen. Informatie betreffende prijs en beschikbaarheid wordt vrijblijvend en onder voorbehoud verstrekt.<br/> b. Klant betaalt voor de door middel van de website bestelde producten dan wel diensten, de in de Overeenkomst vermelde prijs. Betaling vindt plaats op de op de website van Stichting LatinMap.com aangegeven wijze. Aan de bestelling kunnen nadere (betalings-/bestel) voorwaarden worden gesteld. </p><p> c. Alle prijzen van Stichting LatinMap.com zoals vermeld op de website zijn in euro's inclusief BTW, tenzij uitdrukkelijk anders wordt vermeld.<br/> d. Stichting LatinMap.com brengt bij elke bestelling servicekosten in rekening. Daarnaast brengt Stichting LatinMap.com administratiekosten in rekening die worden berekend op basis van het totale bedrag van de transactie. </p><p> e. Indien Klant de verschuldigde bedragen niet tijdig betaalt, is Klant, zonder dat enige aanmaning of ingebrekestelling nodig is, over het openstaande bedrag wettelijke rente verschuldigd. Indien Klant na aanmaning of ingebrekestelling nalatig blijft de vordering te voldoen, kan Stichting LatinMap.com de vordering uit handen geven, in welk geval Klant naast het dan verschuldigde totale bedrag tevens gehouden is tot vergoeding van alle gerechtelijke en buitengerechtelijke kosten, waaronder kosten berekend door externe deskundigen naast de in rechte vastgestelde kosten. </p><p> 5. Levertermijnen </p><p> a. Tickets worden verzonden naar het (e-mail)adres dat Klant heeft opgegeven bij de bestelling. Stichting LatinMap.com zal het door Klant opgegeven (e-mail)adres als juist blijven beschouwen, totdat Klant aan Stichting LatinMap.com een nieuw (e-mail)adres heeft meegedeeld. b. De door Stichting LatinMap.com opgegeven levertijden zullen nimmer te beschouwen zijn als fatale termijn, tenzij uitdrukkelijk anders is overeengekomen. Bij niet tijdige levering dient Stichting LatinMap.com schriftelijk in gebreke te worden gesteld. </p><p> c. Overschrijding van enige leveringstermijn geeft Klant geen recht op schadevergoeding en evenmin het recht om de bestelling te annuleren dan wel de Overeenkomst te ontbinden, tenzij de overschrijding van de leveringstermijn zodanig is dat van Klant redelijkerwijs niet kan worden verlangd dat deze de Overeenkomst in stand laat. </p><p> d. Met uitzondering van de mogelijkheid om elektronische Tickets te bestellen, wordt de verkoop van Tickets via de website en het callcenter 8 dagen voor de datum van het Evenement gestaakt om Stichting LatinMap.com de gelegenheid te geven de Tickets nog per post te versturen. </p><p> 6. Afgelaste en verschoven evenementen </p><p> a. Het is de verantwoordelijkheid van Klant om na te gaan of een Evenement is afgelast of verschoven en wat de nieuwe tijd of locatie zal zijn. Hoewel Stichting LatinMap.com zal proberen Klant van de afgelasting op de hoogte te brengen nadat Stichting LatinMap.com de benodigde informatie van de Evenementhouder heeft ontvangen, kan Stichting LatinMap.com niet garanderen dat Klant van de afgelasting op de hoogte gebracht zal worden voor de datum van het Evenement. </p><p> b. Stichting LatinMap.com is niet verantwoordelijk voor eventueel gemaakte kosten.<br/> c. Tickets van verschoven Evenementen blijven in de regel geldig voor het vervangende Evenement. Voor meer informatie hierover kan Klant contact met Stichting LatinMap.com opnemen via ons email adres: mail(at)LatinMap.com Indien een Evenement wordt verschoven naar een andere locatie of datum, kan de Evenementhouder voorwaarden stellen aan de vergoeding van de ticketprijs.<br/> d. Indien een Evenement wordt afgelast of verschoven, dan kan Klant de Tickets voor dit Evenement inleveren conform de regeling zoals bepaald door de Evenementhouder. Voor de betreffende voorwaarden verwijzen wij u naar de Algemene Voorwaarden van de organisator van het evenement. Indien de Evenementhouder Stichting LatinMap.com verzoekt om de Klant de ticketprijs te restitueren, dan zal Stichting LatinMap.com dit doen nadat zij de betreffende gelden van de Evenementhouder heeft ontvangen. Service- en administratiekosten worden niet gerestitueerd. </p><p> 7. Tickets </p><p> a. De door Stichting LatinMap.com gedistribueerde Tickets blijven eigendom van de Evenementhouder. Het is de Klant niet toegestaan om een Ticket door te verkopen indien dit in strijd is met de wet. Daarnaast kan een Evenementhouder de doorverkoop of het gebruik op commerciële wijze van een Ticket verbieden. De Klant dient dit na te gaan in de algemene voorwaarden van de organisator, waar op het Ticket (en gedurende het bestelproces) naar wordt verwezen. Bij (poging tot) doorverkoop of commercieel gebruik in strijd met de wet of de voorwaarden van de Evenementhouder, is de Evenementhouder gerechtigd het betreffende Ticket ongeldig te maken en/of de Klant een boete op te leggen. Houders van ongeldige toegangsbewijzen zal de toegang tot het Evenement worden ontzegd, zonder recht op schadevergoeding.<br/> b. Na ontvangst dient Klant de Tickets te controleren, aangezien fouten niet altijd kunnen worden hersteld. Na aanschaf kunnen Tickets niet meer geruild of vergoed worden.<br/> c. Indien het Ticket van Klant zodanig is beschadigd dat het niet meer op echtheid te controleren is, kan Klant contact opnemen met online klantenservice.<br/> d. Speciale wensen, zoals het reserveren van rolstoelplaatsen, dienen tijdig en uitdrukkelijk </p><p> kenbaar te worden gemaakt. Stichting LatinMap.com kan geen enkele garantie geven dat aan speciale wensen tegemoet kan worden gekomen. Voor meer informatie hierover kan Klant contact met Stichting LatinMap.com opnemen via ons email adres: mail(at)LatinMap.com </p><p> 8. Intellectuele en industriële eigendomsrechten </p><p> a. De op het Ticket van Stichting LatinMap.com rustende industriële en intellectuele eigendomsrechten behoren toe aan Stichting LatinMap.com dan wel haar licentiegever. Klant zal zich onthouden van gedragingen waardoor rechten of andere belangen te dier zake van Stichting LatinMap.com dan wel haar licentiegever zouden kunnen worden geschaad.<br/> b. Het is Klant niet toegestaan enige aanduiding betreffende auteursrechten, merken, handelsnamen of andere rechten van intellectuele of industriële eigendom van het Ticket te verwijderen of te wijzigen, danwel enige wijziging aan te brengen in de vorm of enig ander kenmerk van het Ticket.<br/> c. Het is Klant verboden het Ticket te vervalsen, te vermenigvuldigen of op enige wijze te reproduceren.<br/> d. De Overeenkomst strekt niet tot de overdracht van enig intellectueel eigendomsrecht van Stichting LatinMap.com aan Klant. </p><p> 9. Privacy </p><p> a. De verstrekte gegevens door de Klant bij aankoop van tickets zullen door Stichting LatinMap.com zullen uitsluitend worden gebruikt om de dienstverlening te verbeteren.<br/> b. De verstrekte gegevens door de Klant bij aankoop van tickets zullen nimmer aan derden beschikbaar worden gesteld. </p><p> c. De verstrekte gegevens door de Klant bij aankoop van tickets komen beschikbaar voor de verkopende Organisatie. Wellicht dat de organisatie de gegevens zal gebruiken voor het versturen van mailings.<br/> d. Van onze opdrachtgevers verwachten we dat ze hiermee zorgvuldig zullen omgaan. Mocht dat niet zo zijn, dan horen we dat graag en zullen we de betreffende opdrachtgever hiervan op de hoogte stellen en indien we dat nodig achten de opdrachtgever uit te sluiten van online ticketverkoop. </p><p> e. Let wel: we stellen ons niet aansprakelijk voor het privacy beleid van onze opdrachtgevers. </p><p> 10. Aansprakelijkheid </p><p> a. Stichting LatinMap.com kan niet worden aangemerkt als de organisator (Evenementhouder) van het Evenement en is niet verantwoordelijk voor en verleent geen garantie op de (artistieke) kwaliteit en inhoud van het Evenement en de gang van zaken in of rond het Evenement en aanvaardt op basis van dit gegeven geen enkele aansprakelijkheid. </p><p> b. Met uitzondering van de overige aansprakelijkheidsbepalingen in deze Algemene Voorwaarden, is de totale aansprakelijkheid van Stichting LatinMap.com wegens toerekenbare tekortkoming in de nakoming, dan wel wegens onrechtmatige daad, beperkt tot vergoeding van directe schade tot ten hoogste het bedrag dat voor de Tickets aan Klant in rekening is of kan worden gebracht, tenzij de schade het gevolg is van opzet en/of grove schuld van </p><p> Stichting LatinMap.com of haar ondergeschikten.<br/> c. De aansprakelijkheid van Stichting LatinMap.com wegens toerekenbare tekortkoming in de nakoming van een overeenkomst ontstaat in alle gevallen slechts indien Klant Stichting LatinMap.com onverwijld en deugdelijk schriftelijk in gebreke stelt, waarbij een redelijke termijn ter zuivering van de tekortkoming wordt gesteld, en Stichting LatinMap.com ook na die termijn toerekenbaar tekort blijft schieten in de nakoming van haar verplichtingen. De ingebrekestelling dient een zo volledig en gedetailleerd mogelijke omschrijving van de tekortkoming te bevatten, zodat Stichting LatinMap.com in staat is adequaat te reageren.<br/> d. Klant vrijwaart Stichting LatinMap.com voor alle aanspraken van derden verband houdende met het niet of onvoldoende naleven door Klant van enige verplichting jegens Stichting LatinMap.com, al dan niet voortvloeiende uit de Algemene Voorwaarden.<br/> e. Voorwaarde voor het ontstaan van enig recht op schadevergoeding is steeds dat Klant de schade zo spoedig mogelijk na het ontstaan daarvan schriftelijk bij Stichting LatinMap.com meldt. f. Stichting LatinMap.com kan op geen enkel moment aansprakelijk worden gehouden voor welke vorm van schade aan of verlies van het Ticket dan ook. Bij verlies of diefstal kan de Klant geen aanspraak maken op een vervangend Ticket of terugbetaling van enige gelden. Stichting LatinMap.com is evenmin aansprakelijk voor vertraging of het niet of onjuist afleveren van Tickets, indien vertraging of het niet of onjuist afleveren niet kan worden toegerekend aan Stichting LatinMap.com.<br/> g. Stichting LatinMap.com aanvaardt op geen enkele wijze aansprakelijkheid voor door Klant bij derde partijen verkregen Tickets. Stichting LatinMap.com kan evenmin de echtheid hiervan garanderen.<br/> h. Stichting LatinMap.com kan op geen enkele wijze aansprakelijk worden gesteld voor enigerlei schade die de houder van dit toegangsbewijs ondervindt door handelen of nalaten van derden. </p><p> 11. Overmacht </p><p> a. Onder overmacht wordt verstaan iedere tekortkoming die niet aan Stichting LatinMap.com kan worden toegerekend, omdat zij niet te wijten is aan haar schuld en noch krachtens de wet, rechtshandeling of in het verkeer geldende opvatting voor haar rekening komt.<br/> b. Onverminderd de overige aan haar toekomende rechten, heeft Stichting LatinMap.com in geval van overmacht het recht om de uitvoering van de bestelling van Klant op te schorten, zulks door dit schriftelijk aan Klant mee te delen en zulks zonder dat Stichting LatinMap.com gehouden is tot enige schadevergoeding, tenzij dit in de gegeven omstandigheden naar maatstaven van redelijkheid en billijkheid onaanvaardbaar zou zijn. </p><p> 12. Toepasselijk recht en bevoegde rechter </p><p> a. Op alle overeenkomsten met Stichting LatinMap.com is Nederlands recht van toepassing. </p><p> 13. Diversen </p><p> a. Klanten die te laat bij het Evenement arriveren, worden &ndash; voor zover mogelijk - toegelaten tijdens geschikte momenten gedurende het Evenement. Toegang kan echter niet worden gegarandeerd.<br/> b. Waar in deze Algemene Voorwaarden Stichting LatinMap.com zich verplicht tot het doen van </p><p> een schriftelijke mededeling, is Stichting LatinMap.com gerechtigd deze mededeling langs elektronische weg te doen, zoals maar niet beperkt tot een e-mailbericht of fax.<br/> c. Kennelijke vergissingen en schrijffouten op de website van Stichting LatinMap.com dan wel in offertes, orderbevestigingen, Tickets en/of andere bescheiden, binden Stichting LatinMap.com niet. d. Bij verschil van mening tussen Stichting LatinMap.com en Klant over de vertaling en/of de uitleg van de Algemene Voorwaarden is de Nederlandse versie ervan beslissend.<br/> e. Indien een of meer van de bepalingen van deze Algemene Voorwaarden of enige andere overeenkomst met Stichting LatinMap.com in strijd mochten zijn met enig toepasselijk rechtsvoorschrift, zal de betreffende bepaling komen te vervallen en zal deze worden vervangen door een door Stichting LatinMap.com vast te stellen nieuwe rechtens toelaatbare vergelijkbare bepaling. </p>",
        },
        'privacy-policy': {
            title: 'Privacybeleid',
            body: "<p>Privacybeleid voor LatinMap.com: Ontdek en Beleef de Latin Danswereld<br />Laatstbijgewerkt: 23-05-2023<br />Bedankt voor het bezoeken van LatinMap.com, d&eacute;bestemming voor het ontdekken en beleven van de Latin danswereld. We hechten veel waardeaan de bescherming van je privacy en willen transparant zijn over hoe we je persoonlijkeinformatie verzamelen, gebruiken, delen en beschermen. Lees dit privacybeleid zorgvuldigdoor om ons beleid en je rechten betreffende je persoonlijke gegevens te begrijpen.<br />1.Informatieverzameling <br />1.1 Persoonlijke informatie: Bij het registreren opLatinMap.com kunnen we persoonlijke informatie van je vragen, zoals je naam,e-mailadres, fysiek adres en telefoonnummer. Deze informatie wordt vrijwillig verstrektdoor jou.<br />1.2 Automatisch verzamelde informatie: We kunnen automatisch bepaaldeinformatie verzamelen wanneer je onze website bezoekt, zoals je IP-adres, browsertype,taalvoorkeuren, toegangstijden en verwijzende website-adressen. Deze informatie wordtgebruikt om trends te analyseren, onze website te beheren en de algehelegebruikerservaring te verbeteren.<br />2. Gebruik van informatie <br />2.1 Persoonlijkeinformatie: We gebruiken je persoonlijke informatie om je toegang te bieden tot dediensten en functionaliteiten van LatinMap.com. Dit omvat het personaliseren van jeervaring, het versturen van relevante meldingen en updates, en het faciliteren vancommunicatie tussen gebruikers (bijvoorbeeld het volgen van favoriete organisatoren,DJ's, dansscholen en artiesten).<br />2.2 Marketingcommunicatie: Indien je ermeeinstemt, kunnen we je e-mails sturen met betrekking tot onze diensten, evenementen enaanbiedingen. Je kunt je op elk moment afmelden voor deze communicatie door deafmeldlink onderaan de e-mails te gebruiken.<br />2.3 Geaggregeerde gegevens: We kunnengeaggregeerde, niet-identificeerbare informatie gebruiken voor statistische analyse,marktonderzoek en andere zakelijke doeleinden.<br />3. Informatiedeling <br />3.1 Derdepartijen: We delen je persoonlijke informatie alleen met derde partijen wanneer ditnodig is om de door jou gevraagde diensten te leveren, zoals organisatoren vanevenementen waarvoor je je hebt geregistreerd. Deze derde partijen zijn gebonden aanvertrouwelijkheidsverplichtingen en mogen je gegevens alleen gebruiken voor het leverenvan de gevraagde diensten.<br />3.2 Juridische vereisten: We kunnen je persoonlijkeinformatie delen als we te goeder trouw geloven dat openbaarmaking noodzakelijk is om tevoldoen aan een wettelijke verplichting, een gerechtelijk bevel of eenoverheidsverzoek.<br />4. Gegevensbeveiliging We nemen redelijke maatregelen om jepersoonlijke informatie te beschermen tegen ongeautoriseerde toegang, gebruik ofopenbaarmaking. We hanteren passende fysieke, technische en organisatorischebeveveiligingsmaatregelen om de vertrouwelijkheid en integriteit van je gegevens tewaarborgen. Dit omvat het gebruik van versleutelingsmethoden, beperkte toegang tot jepersoonlijke informatie en regelmatige evaluaties van onze beveiligingspraktijken.<br />5.Bewaartermijn van gegevens We bewaren je persoonlijke informatie alleen zo lang alsnodig is om de doeleinden te vervullen waarvoor de informatie is verzameld, tenzij eenlangere bewaartermijn wettelijk vereist of toegestaan is.<br />6. Cookies envergelijkbare technologie&euml;n We kunnen gebruikmaken van cookies en vergelijkbaretechnologie&euml;n om informatie te verzamelen en je ervaring op LatinMap.com teverbeteren. Je kunt je browserinstellingen aanpassen om het gebruik van cookies tebeheren of te blokkeren, maar houd er rekening mee dat sommige functies van onze websitemogelijk niet goed werken als cookies zijn uitgeschakeld.<br />7. Externe links Onzewebsite kan links bevatten naar andere websites van derden. We hebben geen controle overdeze websites en zijn niet verantwoordelijk voor hun privacypraktijken. We raden je aanom het privacybeleid van elke website die je bezoekt te lezen.<br />8. Je rechten Jehebt het recht om toegang te vragen tot je persoonlijke informatie die we bewaren en omeventuele onjuistheden te corrigeren. Je kunt ook verzoeken om de verwijdering van jepersoonlijke informatie, tenzij we wettelijk verplicht zijn om deze te bewaren. Neemcontact met ons op via de onderstaande contactgegevens om gebruik te maken van dezerechten.<br />9. Wijzigingen in het privacybeleid We kunnen dit privacybeleid van tijdtot tijd bijwerken. Eventuele wijzigingen zullen op deze pagina worden geplaatst en deherziene versie van het privacybeleid zal de ingangsdatum bovenaan vermelden.<br />10.Neem contact met ons op Als je vragen hebt over dit privacybeleid of de manier waarop weje persoonlijke informatie verzamelen, gebruiken of delen, kun je contact met onsopnemen via [contactgegevens].<br />Bedankt dat je ons privacybeleid hebt gelezen. Westreven ernaar om je privacy te beschermen en je een veilige en bevredigendegebruikerservaring te bieden op LatinMap.com.</p>",
        },
        about: {
            'about-latin-scene': {
                title: 'Over de Latin scene',
                body: 'De Latijnse dansscene is een levendige en diverse gemeenschap die mensen van over de hele wereld samenbrengt. Het is een wereld vol passie, ritme en creativiteit, waar mensen samenkomen om te dansen, te leren en te genieten van de rijke cultuur van Latijns-Amerika. Of je nu een ervaren danser bent of net begint, er is voor iedereen iets te ontdekken en te beleven in de Latijnse danswereld.',
            },
            salsa: {
                title: 'Salsa',
                body: 'Salsa is een populaire dansstijl die zijn oorsprong vindt in de Caribische regio. Het is een levendige en ritmische dans die wordt gekenmerkt door zijn energieke bewegingen en sensuele ritmes. Salsa is een sociale dans die wordt gedanst op een verscheidenheid aan muziekstijlen, waaronder Salsa, Mambo, Cha Cha Cha en Merengue. Het is een dans die mensen van alle leeftijden en achtergronden samenbrengt en een gevoel van gemeenschap en verbondenheid creëert.',
            },
            bachata: {
                title: 'Bachata',
                body: 'Bachata is een romantische en sensuele dans die zijn oorsprong vindt in de Dominicaanse Republiek. Het is een langzame en gepassioneerde dans die wordt gedanst op de zwoele klanken van de Bachata muziek. Bachata is een intieme dans die draait om connectie en emotie, en wordt vaak gedanst in paren. Het is een dans die de liefde en passie van de Latijnse cultuur weerspiegelt.',
            },
            zouk: {
                title: 'Zouk',
                body: 'Zouk is een sensuele en ritmische dans die zijn oorsprong vindt in de Franse Antillen. Het is een dans die draait om beweging en connectie, en wordt gedanst op de hypnotiserende klanken van de Zouk muziek. Zouk is een dans die de vrijheid en creativiteit van de Latijnse cultuur weerspiegelt, en wordt vaak gedanst in een intieme en expressieve stijl.',
            },
            kizomba: {
                title: 'Kizomba',
                body: 'Kizomba is een muziekgenre en dansstijl die zijn oorsprong vindt in Angola in de late jaren 1970 en vroege jaren 1980. Bekend om zijn langzame, sensuele ritme en nauwe partnerverbinding, benadrukt Kizomba soepele, vloeiende bewegingen en ingewikkeld voetwerk. Het is wereldwijd in populariteit gegroeid en combineert Afrikaanse ritmes met moderne invloeden.',
            },
            cuban: {
                title: 'Cubaans',
                body: 'Cubaans muziek en dans zijn diep geworteld in het diverse culturele erfgoed van het eiland, waarbij Afrikaanse, Spaanse en inheemse invloeden worden gecombineerd. Bekend om zijn levendige en ritmische stijlen zoals Salsa, Rumba en Son, kenmerkt de Cubaanse dans zich door energieke bewegingen, ingewikkelde voetwerk en een sterke verbinding met de muziek. Het is een levendige, expressieve dansvorm die wereldwijd wordt gevierd.',
            },
        },
        'help-center-faq': {
            title: 'Helpcentrum & FAQ',
        },
        'cookie-policy': {
            title: 'Cookiebeleid',
        },
        'create-an-event': {
            title: 'Hoe u een evenement maakt',
        },
        'create-an-brand-or-an-organization': {
            title: 'Hoe u een merk kunt maken',
        },
        'become-an-ambassador': {
            title: 'Word een ambassadeur',
        },
        'promote-your-event': {
            title: 'Hoe u uw evenement kunt promoten',
        },
        'professional-account-verification': {
            title: 'Professionele accountverificatie',
        },
        'about-us': {
            title: 'Over ons',
        },
    },
    email: {
        'not-unique': 'Dit e-mailadres is al in gebruik',
    },
    leads: {
        title: 'Lead indienen',
        description_p1:
            'Ben je een LatinMap gebruiker en heb je een dansschool, organisatie of evenement gevonden dat nog niet vermeld staat? Dien het hier in — jouw bijdrage helpt ons het platform compleet, accuraat en waardevol te houden voor dansers wereldwijd.',
        description_p2:
            'Ben je een organisator en wil je op LatinMap vermeld worden? Maak een Pro Account aan en voeg je activiteiten gratis toe aan het platform!',
        description_p3:
            'Bedankt dat je ons helpt LatinMap te laten groeien, het platform dat de wereldwijde dansgemeenschap verbindt.',
        plural: 'Leads',
        type: {
            event: 'Event',
            organization: 'Organisatie',
            label: 'Type',
        },
        name: 'Naam',
        address: 'Adres',
        country: 'Land',
        city: 'Stad',
        street: 'Straat',
        street_number: 'Huisnummer',
        dance_styles: 'Dansstijlen',
        music_styles: 'Muziekstijlen',
        photos: "Foto's",
        category: 'Categorie',
        location_name: 'Locatie naam',
        location_type: {
            singular: 'Locatietype',
            online: 'Virtueel',
            offline: 'Persoonlijk',
        },
        timezone: 'Tijdzone',
        date: 'Datum',
        not_posted_by_ambassador: 'Geverifieerd door organisatie & Brand',
        undercondition: 'Onder voorbehoud',
        warning: 'Belangrijke wijziging',
        cancelled: 'Geannuleerd',
        posted_by_ambassador: 'Gepost door LatinMap Ambassador',
        upcoming: 'Aankomende events',
        status_options: {
            active: 'Actief',
            canceled: 'Geannuleerd',
            pending: 'Nog niet bevestigd',
            changed: 'Belangrijke wijziging',
            submitted: 'Ingediend',
            under_review: 'In beoordeling',
            implemented: 'Geïmplementeerd',
            declined: 'Afgewezen',
        },
        submit: 'Indienen',
        success: 'De lead is succesvol ingediend',
        unavailable: 'Leads indienen is niet meer beschikbaar.',
        filter_type: 'Filter op type',
        view: 'Lead',
        confirm_delete: 'Lead verwijderen',
        delete_confirmation: 'Weet u zeker dat u deze lead wilt verwijderen?',
        deleted_successfully: 'De lead is succesvol verwijderd.',
        error_loading: 'Fout bij het laden van leads',
        status_updated: 'De leadstatus is bijgewerkt.',
        error_status: 'Fout bij het bijwerken van de leadstatus.',
    },
    search: {
        allOragnisations: 'Bekijk alle dans scholen',
        allEvents: 'Bekijk alle evenementen',
        searchresult: 'Zoekresultaten',
        type: 'Type',
        title: 'Titel',
        brand: 'Brand',
        city: 'Stad',
        country: 'Land',
        address: 'Adres',
        startdate: 'Startdatum',
        favorite: 'Favoriet',
    },
    components: {
        picture_input: {
            drag: 'Avatar uploaden',
            remove: 'Avatar verwijderen',
            change_avatar: 'Avatar aanpassen',
        },
        pictureInput: {
            drag: 'Klik hier om foto te uploaden',
            change: 'Wijzigen',
            remove: 'Verwijderen',
            upload: 'Uploaden',
            tap: 'Tik om te uploaden',
            select: 'Selecteer een bestand',
            selected: 'Geselecteerd',
            fileSize: 'Bestandsgrootte',
            fileType: 'Bestandstype',
            aspect: 'Beeldverhouding',
        },
    },
    passion: {
        title: 'Voel het Ritme, Word Onderdeel van de Beweging',
        subtitle:
            'Ontdek de levendige wereld van Latin dance. Maak contact met dansers, vind evenementen bij jou in de buurt en laat de muziek je ziel raken.',
    },
    payment: {
        received: 'Betaling ontvangen',
        thank_you:
            'Bedankt voor je aankoop! We zijn blij te kunnen informeren dat je betaling succesvol is ontvangen. Je tickets zijn gegenereerd en naar het opgegeven e-mailadres gestuurd.',
        download_ticket: 'Download ticket(s)',
        download_button: 'Download ticket(s)',
        email_check:
            'Controleer je inbox, inclusief de spammap, voor een e-mail van ons ticketsysteem. Mocht je problemen ondervinden of vragen hebben, dan staat ons klantenserviceteam klaar om je te helpen. We hopen dat je een geweldige ervaring hebt op het evenement en danken je nogmaals voor het kiezen van onze ticketshop.',
        failed: 'Betaling in behandeling',
        failed_message:
            'Helaas is er een probleem opgetreden bij het verwerken van je betaling. De transactie is geannuleerd of verlopen. Probeer het opnieuw, en als het probleem aanhoudt, neem dan contact op met onze klantenservice voor assistentie.',
        thank_you_for_purchase:
            'Dank u wel voor het aankopen van het uitgelichte evenement! U kunt de factuur hieronder downloaden.',
        download_invoice: 'Download factuur',
        download_invoice_button: 'Download factuur',
        invoice_check: 'Controleer uw inbox voor uw factuur.',
    },
    financial_center: {
        financial_dashboard: 'Mijn financiële dashboard',
        title: 'Financieel Centrum',
        description: 'Beheer je transacties, uitbetalingen, promoties en premium functies.',
        overview: 'Overzicht',
        transactions: 'Transacties',
        payoutsettings: 'Uitbetalingsinstellingen',
        featured_events: 'Uitgelichte evenementen',
        ticketsales: 'Ticketverkoop',
        premium: 'Premium accounts',
    },
    inputfield: {
        select_here: 'Selecteer hier',
    },
    tooltip: {
        edit: 'Bewerken',
        delete: 'Verwijderen',
        view: 'Bekijken',
        hide: 'Verbergen',
        under_construction: 'In aanbouw',
    },
    // LA-157: where someone stops the automated emails LatinMap sends.
    email_preferences: {
        error: 'Er ging iets mis. Probeer het zo nog eens.',
        confirm: {
            title: 'Geen e-mails meer?',
            body: 'Je krijgt deze automatische e-mails nu op {email}.',
            note: 'Berichten over je account, zoals wachtwoord herstellen, blijven we wel sturen.',
            button: 'Stop deze e-mails',
        },
        done: {
            title: 'Je krijgt niets meer',
            body: 'We sturen geen automatische e-mails meer naar {email}.',
            undo: 'Toch weer ontvangen',
        },
        unknown: {
            title: 'Deze link werkt niet meer',
            body: 'De link is ongeldig. Gebruik de link uit een recentere e-mail.',
        },
    },
    // LA-194: the public page an organiser reaches through a submission link.
    submit_event: {
        eyebrow: 'Event insturen',
        title: 'Stuur je event in bij LatinMap',
        title_brand: 'Stuur een event in voor {brand}',
        lede: 'Vul in wat je weet. Wij zetten het klaar en publiceren het na een korte controle.',
        loading: 'Even geduld…',
        notes: {
            no_account: 'Geen account nodig — deze link is genoeg',
            checked: 'Wij controleren elk event voordat het online komt',
            reply: 'Is iets onduidelijk, dan mailen we je',
        },
        sections: {
            event: 'Het event',
            where: 'Waar',
            details: 'Toelichting',
            more: 'Meer details (optioneel)',
            you: 'Jouw gegevens',
        },
        fields: {
            name: 'Naam van het event',
            organizer_name: 'Naam organisator / brand',
            organizer_url: 'Website of socials van de organisator',
            start_date: 'Datum',
            start_time: 'Begintijd',
            end_date: 'Einddatum',
            end_time: 'Eindtijd',
            dance_styles: 'Dansstijlen',
            event_category: 'Soort event',
            event_category_placeholder: 'Kies een soort event',
            location_name: 'Locatie',
            city: 'Stad',
            country: 'Land',
            country_placeholder: 'Kies een land',
            timezone_placeholder: 'Kies een tijdzone',
            short_description: 'Korte omschrijving',
            description: 'Uitgebreide omschrijving',
            photo_remove: 'Foto verwijderen',
            your_name: 'Je naam',
            your_email: 'Je e-mailadres',
        },
        hints: {
            organizer:
                'Wie organiseert dit event? Een link naar de website of Instagram helpt ons de juiste brand te vinden.',
            end_date: 'Bij een event van één dag is dit dezelfde datum als de begindatum.',
            contact: 'We gebruiken dit alleen om contact op te nemen over dit event.',
            photos: "Maximaal 5 foto's. JPG, PNG of WebP, elk maximaal 8 MB.",
            comma_separated: 'Scheid namen met een komma.',
        },
        errors: {
            name: 'Vul de naam van het event in.',
            start_date: 'Vul de datum in.',
            end_date: 'Vul de einddatum in.',
            event_category: 'Kies een soort event.',
            too_many: 'Je hebt het te vaak geprobeerd. Wacht even en probeer het daarna opnieuw.',
            city: 'Vul de stad in.',
            country: 'Kies een land.',
            timezone: 'Kies een tijdzone.',
            organizer_name: 'Vul in wie dit event organiseert.',
            email: 'Vul een geldig e-mailadres in.',
            failed: 'Het insturen is niet gelukt. Probeer het zo nog eens.',
            photo_type: 'Kies een JPG, PNG of WebP.',
            photo_size: 'Deze foto is te groot. Maximaal 8 MB.',
            photos_required: 'Voeg minstens \u00e9\u00e9n foto toe.',
            photos_max: "Je kunt maximaal {max} foto's toevoegen \u2014 de rest is niet meegestuurd.",
        },
        submit: 'Event insturen',
        done: {
            title: 'Bedankt, we hebben je event',
            body: 'Iemand van LatinMap kijkt ernaar. Je krijgt een bevestiging per e-mail.',
            again: 'Nog een event insturen',
        },
        invalid: {
            title: 'Deze link werkt niet meer',
            body: 'De link is verlopen of ingetrokken. Vraag degene die hem stuurde om een nieuwe.',
        },
    },
    // LA-180: the screen Brevo returns to after a subscription is
    // confirmed. Top-level rather than under footer, because the same
    // confirmation ends both the footer form and the signup opt-in.
    newsletter: {
        // LA-176: the fixed sign-up landing page behind every QR code,
        // social bio and e-mail signature.
        stay_updated: {
            title: 'Blijf dicht bij de scene',
            lede: "Ontvang de Latin dance events waarvoor je je avond vrijhoudt — party's, festivals, workshops en try-outs, plus nieuwe features en winacties van LatinMap.",
            benefits: {
                agenda: 'De agenda, eerder dan de rest',
                festivals: 'Festivals en congressen waarvoor je reist',
                features: 'Nieuwe LatinMap-features zodra ze er zijn',
                community: 'Winacties en nieuws uit de community',
            },
            form_title: 'Aanmelden',
            email_label: 'Je e-mailadres',
            submit: 'Zet me op de lijst',
            terms: 'Eén mail tegelijk, en je adres gaat nooit naar iemand anders. Afmelden kan met één klik, in elke mail.',
            done: {
                title: 'Check je inbox',
                body: 'We hebben je één mail gestuurd. Klik op de link erin om te bevestigen, dan sta je op de lijst.',
                again: 'Nog een adres aanmelden',
            },
        },
        confirmed: {
            title: 'Aanmelding bevestigd',
            success: 'Je aanmelding is bevestigd. Welkom!',
            body: 'Je ontvangt vanaf nu de LatinMap nieuwsbrief: de beste Latin dance events rechtstreeks in je inbox. Afmelden kan met één klik, in elke nieuwsbrief.',
            discover_events: 'Ontdek events',
            back_home: 'Terug naar home',
        },
    },
    footer: {
        newsletter: {
            title: 'Blijf op de hoogte',
            subtitle: 'Ontvang de beste Latin dance events rechtstreeks in je inbox.',
            placeholder: 'Je e-mailadres',
            button: 'Aanmelden',
            subscribing: 'Bezig met aanmelden…',
            success: 'Je bent aangemeld! Check je inbox om te bevestigen.',
            error: 'Er ging iets mis. Probeer het opnieuw.',
            invalid_email: 'Voer een geldig e-mailadres in.',
            terms: 'Door je aan te melden ga je akkoord met ons privacybeleid. Je kunt je altijd afmelden.',
        },
        section_1: {
            title: 'Discover LatinMap',
            about: 'Over ons',
            how_it_works: 'Hoe het werkt',
            search: 'Zoeken',
            contact: 'Contact',
        },
        section_2: {
            title: 'Support & Community',
            help: 'Helpcentrum & FAQ',
            privacy_policy: 'Privacybeleid',
            terms_and_conditions: 'Algemene voorwaarden',
            cookie_policy: 'Cookiebeleid',
            cookie_settings: 'Cookie-instellingen',
        },
        section_3: {
            title: 'voor professionals',
            create_event: 'Hoe u een evenement maakt',
            create_organization: 'Hoe u een merk kunt maken',
            become_ambassador: 'Word een ambassadeur',
            promote_event: 'Hoe u uw evenement kunt promoten',
            professional_account_verification: 'Professionele accountverificatie',
        },
        section_4: {
            title: 'Dance & Event Categories',
            all_events: 'All evenementen',
        },
        follow_our_socials: 'Social Media & Volgen',
    },
};
